export const infrastructuresData = [
  {
    id: 1,
    title: "35944",
    geolocation: {
      latitude: 40.6352198,
      longitude: 22.9355045,
    },
    image: null,
    category: {
      id: 1,
      name: "\u03a1\u03ac\u03bc\u03c0\u03b5\u03c2",
    },
    type: {
      id: 2,
      name: "\u0394\u03b7\u03bc\u03cc\u03c3\u03b9\u03b1",
    },
  },
  {
    id: 2,
    title: "35945",
    geolocation: {
      latitude: 40.6352121,
      longitude: 22.9354896,
    },
    image: null,
    category: {
      id: 3,
      name: "\u03a0\u03b5\u03b6\u03bf\u03b4\u03c1\u03cc\u03bc\u03b9\u03b1 \u0391\u039c\u0395\u0391",
    },
    type: {
      id: 2,
      name: "\u0394\u03b7\u03bc\u03cc\u03c3\u03b9\u03b1",
    },
  },
  {
    id: 3,
    title: "35946",
    geolocation: {
      latitude: 40.6524485,
      longitude: 22.931053,
    },
    image: null,
    category: {
      id: 9,
      name: "\u0386\u03bb\u03bb\u03bf",
    },
    type: {
      id: 2,
      name: "\u0394\u03b7\u03bc\u03cc\u03c3\u03b9\u03b1",
    },
  },
  {
    id: 4,
    title: "35947",
    geolocation: {
      latitude: 40.6528552,
      longitude: 22.9308595,
    },
    image: null,
    category: {
      id: 9,
      name: "\u0386\u03bb\u03bb\u03bf",
    },
    type: {
      id: 2,
      name: "\u0394\u03b7\u03bc\u03cc\u03c3\u03b9\u03b1",
    },
  },
  {
    id: 5,
    title: "35948",
    geolocation: {
      latitude: 40.6533625,
      longitude: 22.9306081,
    },
    image: null,
    category: {
      id: 9,
      name: "\u0386\u03bb\u03bb\u03bf",
    },
    type: {
      id: 2,
      name: "\u0394\u03b7\u03bc\u03cc\u03c3\u03b9\u03b1",
    },
  },
  {
    id: 6,
    title: "35949",
    geolocation: {
      latitude: 40.6533945,
      longitude: 22.9305496,
    },
    image: null,
    category: {
      id: 9,
      name: "\u0386\u03bb\u03bb\u03bf",
    },
    type: {
      id: 2,
      name: "\u0394\u03b7\u03bc\u03cc\u03c3\u03b9\u03b1",
    },
  },
  {
    id: 7,
    title: "35950",
    geolocation: {
      latitude: 40.6538211,
      longitude: 22.9300353,
    },
    image: null,
    category: {
      id: 9,
      name: "\u0386\u03bb\u03bb\u03bf",
    },
    type: {
      id: 2,
      name: "\u0394\u03b7\u03bc\u03cc\u03c3\u03b9\u03b1",
    },
  },
  {
    id: 8,
    title: "35951",
    geolocation: {
      latitude: 40.6538672,
      longitude: 22.929941,
    },
    image: null,
    category: {
      id: 9,
      name: "\u0386\u03bb\u03bb\u03bf",
    },
    type: {
      id: 2,
      name: "\u0394\u03b7\u03bc\u03cc\u03c3\u03b9\u03b1",
    },
  },
  {
    id: 9,
    title: "35952",
    geolocation: {
      latitude: 40.6537141,
      longitude: 22.9298824,
    },
    image: null,
    category: {
      id: 9,
      name: "\u0386\u03bb\u03bb\u03bf",
    },
    type: {
      id: 4,
      name: "\u0399\u03b4\u03b9\u03c9\u03c4\u03b9\u03ba\u03ae",
    },
  },
  {
    id: 15,
    title: "35958",
    geolocation: {
      latitude: 40.6530116,
      longitude: 22.9289488,
    },
    image: null,
    category: {
      id: 9,
      name: "\u0386\u03bb\u03bb\u03bf",
    },
    type: {
      id: 2,
      name: "\u0394\u03b7\u03bc\u03cc\u03c3\u03b9\u03b1",
    },
  },
  {
    id: 31,
    title: "35974",
    geolocation: {
      latitude: 40.6527793,
      longitude: 22.9296652,
    },
    image: null,
    category: {
      id: 3,
      name: "\u03a0\u03b5\u03b6\u03bf\u03b4\u03c1\u03cc\u03bc\u03b9\u03b1 \u0391\u039c\u0395\u0391",
    },
    type: {
      id: 2,
      name: "\u0394\u03b7\u03bc\u03cc\u03c3\u03b9\u03b1",
    },
  },
  {
    id: 16,
    title: "35959",
    geolocation: {
      latitude: 40.6529496,
      longitude: 22.9293622,
    },
    image: null,
    category: {
      id: 3,
      name: "\u03a0\u03b5\u03b6\u03bf\u03b4\u03c1\u03cc\u03bc\u03b9\u03b1 \u0391\u039c\u0395\u0391",
    },
    type: {
      id: 2,
      name: "\u0394\u03b7\u03bc\u03cc\u03c3\u03b9\u03b1",
    },
  },
  {
    id: 17,
    title: "35960",
    geolocation: {
      latitude: 40.6529496,
      longitude: 22.9293622,
    },
    image: null,
    category: {
      id: 3,
      name: "\u03a0\u03b5\u03b6\u03bf\u03b4\u03c1\u03cc\u03bc\u03b9\u03b1 \u0391\u039c\u0395\u0391",
    },
    type: {
      id: 2,
      name: "\u0394\u03b7\u03bc\u03cc\u03c3\u03b9\u03b1",
    },
  },
  {
    id: 18,
    title: "35961",
    geolocation: {
      latitude: 40.6531199,
      longitude: 22.9290779,
    },
    image: null,
    category: {
      id: 1,
      name: "\u03a1\u03ac\u03bc\u03c0\u03b5\u03c2",
    },
    type: {
      id: 2,
      name: "\u0394\u03b7\u03bc\u03cc\u03c3\u03b9\u03b1",
    },
  },
  {
    id: 19,
    title: "35962",
    geolocation: {
      latitude: 40.6530366,
      longitude: 22.9291694,
    },
    image: null,
    category: {
      id: 1,
      name: "\u03a1\u03ac\u03bc\u03c0\u03b5\u03c2",
    },
    type: {
      id: 2,
      name: "\u0394\u03b7\u03bc\u03cc\u03c3\u03b9\u03b1",
    },
  },
  {
    id: 20,
    title: "35963",
    geolocation: {
      latitude: 40.6529639,
      longitude: 22.9292261,
    },
    image: null,
    category: {
      id: 1,
      name: "\u03a1\u03ac\u03bc\u03c0\u03b5\u03c2",
    },
    type: {
      id: 2,
      name: "\u0394\u03b7\u03bc\u03cc\u03c3\u03b9\u03b1",
    },
  },
];

export const infrastructureCategoryFilters = [
  { typeId: "1", type: "category", name: "Ράμπες", isActive: true },
  { typeId: "3", type: "category", name: "Πεζοδρόμια ΑΜΕΑ", isActive: true },
  { typeId: "5", type: "category", name: "Αποδητήρια ΑΜΕΑ", isActive: true },
  { typeId: "6", type: "category", name: "Διάβαση τυφλών", isActive: true },
  { typeId: "7", type: "category", name: "Φανάρι με ήχο", isActive: true },
  {
    typeId: "8",
    type: "category",
    name: "Ανελκυστήρες ΑΜΕΑ",
    isActive: true,
  },
  { typeId: "9", type: "category", name: "Άλλο", isActive: true },
];

export const infrastructureTypeFilters = [
  { typeId: "2", type: "type", name: "Δημόσια", isActive: true },
  { typeId: "4", type: "type", name: "Ιδιωτική", isActive: true },
];

export const getCategoryInfos = (categoryId) => {
  switch (categoryId) {
    case "1":
      return {
        title: "Περιβαλλοντικά Δεδομένα",
        tooltip: "Δεδομένα που αφορούν τις περιβαλλοντικες συνθήκες",
        bgColor: "#33D553",
        icon: "im-icon-Globe",
        mapContent: ["title", "dataIcons"],
        size: "large",
        mapOnTile: false,
      };
    case "2":
      return {
        title: "Συνάθροιση Κοινού",
        tooltip:
          "Αριθμητικά δεδομένα που αφορούν την συνάθροιση των δημοτών σε συγκεκριμένα σημεία της πόλης.",
        mapTitle: "Δεδομένα Συνάθροισης Κοινού",
        bgColor: "#FB5606",
        icon: "im-icon-Business-Mens",
        mapContent: ["title", "dataIcons"], // ["address", "neighborhood", "dataIcons"],
        size: "normal", // large: 280 x 560, normal: 280 x 275,
        mapOnTile: false,
      };
    case "4":
      return {
        title: "WiFi Hotspots",
        tooltip:
          "Σημεία δωρεάν και ελεύθερης πρόσβασης στο διαδίκτυο μέσω WiFi",
        bgColor: "#FF006E",
        icon: "im-icon-Wifi",
        mapContent: ["name", "address"],
        size: "large", // large: 280 x 560, normal: 280 x 275
        mapOnTile: true,
      };
    case "5":
      return {
        title: "Μετεωρολογικά Δεδομένα",
        tooltip: "Δείτε απευθείας τα μετεωρολογικά δεδομένα της περιοχής μας",
        bgColor: "#FFBE0A",
        icon: "im-icon-Cloud-Sun",
        mapContent: ["title", "dataIcons"],
        size: "large", // large: 280 x 560, normal: 280 x 275
        mapOnTile: false,
      };
    case "6":
      return {
        title: "Ποιότητα Υδάτων",
        tooltip:
          "Δεδομένα που αφορούν την ποιότητα του νερού (ph, οξυγόνο κλπ.)",
        mapTitle: "Δεδομένα Ποιότητας Υδάτων",
        bgColor: "#00A1FF",
        icon: "im-icon-Drop",
        mapContent: ["title", "name", "dataIcons"],
        size: "normal", // large: 280 x 560, normal: 280 x 275
        mapOnTile: false,
      };
    case "7":
      return {
        title: "Σημεία ενδιαφέροντος",
        tooltip: "",
        bgColor: "#CB6DE9",
        icon: "im-icon-Map-Marker",
        mapContent: ["name", "address"],
        size: "normal",
        mapOnTile: true,
      };
    case "8":
      return {
        title: "Διαχ/ση Στόλου",
        tooltip:
          "Δείτε την τοποθεσία του στόλου των απορριματοφόρων για την αποκομιδή των σκουπιδιών",
        mapTitle: "Δρομολόγια Απορριμματοφόρων",
        bgColor: "#FF8700",
        icon: "im-icon-Truck",
        mapContent: ["title", "category"],
        size: "large",
        mapOnTile: true,
      };
    case "9":
      return {
        title: "Κάδοι",
        tooltip: "Δείτε σε πραγματικό χρόνο την πληρότητα κάδων",
        mapTitle: "Πληρότητα κάδων",
        bgColor: "#179D00",
        icon: "im-icon-Recycling", // dynamic icon
        mapContent: ["address", "binLevel"],
        size: "large",
        mapOnTile: true,
      };
    case "10":
      return {
        title: "Υδρόμετρα",
        tooltip:
          "Δεδομένα που αφορούν την κατανάλωση νερού σε επιλεγμένες παροχές",
        mapTitle: "Υδρόμετρα",
        bgColor: "#357BEB",
        icon: "im-icon-Gaugage",
        mapContent: ["type", "timestamp"],
        size: "large",
        mapOnTile: true,
      };
    case "11":
      return {
        title: "Αστική κινητικότητα",
        tooltip: "Αισθητήρες κίνησης στους δρόμους",
        bgColor: "#6E93FF",
        icon: "im-icon-Satelite",
        mapContent: ["address", "sensor"],
        size: "large",
        mapOnTile: false,
      };
    case "12":
      return {
        title: "Κατανάλωση ενέργειας",
        tooltip: "Κατανάλωση τελευταίας ώρας",
        mapTitle: "Κατανάλωση Eνέργειας",
        bgColor: "#CB6DE9",
        mapBgColor: "",
        icon: "im-icon-On-Off-3",
        mapContent: ["name", "city", "dataIcons"],
        size: "large",
        mapOnTile: false,
      };
    case "13":
      return {
        title: "Ζύγιση Απορριμμάτων",
        tooltip: "Αποκομιδή απορριμάτων",
        bgColor: "#18D786",
        icon: "im-icon-Mine",
        mapContent: [],
        size: "large",
        mapOnTile: true,
      };
    case "24":
      return {
        title: "Θέσεις Στάθμευσης",
        tooltip: "Ελεύθερες θέσεις για το PARKING",
        mapTitle: "Αισθητήρες στάθμευσης",
        bgColor: "#CB6DE9",
        icon: "im-icon-Car-2", // ο δήμος Πέλλας έχει το εικονίδιο
        mapContent: ["address", "plirotita"],
        size: "normal",
        mapOnTile: false,
      };
    case "28":
      return {
        title: "Δεξαμενή",
        tooltip: "Δεδομένα που αφορούν την κατάσταση των δεξαμενών νερού",
        mapTitle: "Στάθμη Δεξαμενής",
        bgColor: "#CB6DE9",
        mapBgColor: "",
        icon: "",
        mapContent: ["title", "name", "dataIcons"],
        size: "large",
        mapOnTile: true,
      };
    case "29":
      return {
        title: "Ηλεκτροφορτιστές",
        // tooltip: "",
        bgColor: "#CB6DE9",
        mapBgColor: "",
        icon: "im-icon-Power-Cable",
        mapContent: ["title"],
        size: "large",
        mapOnTile: true,
      };
    case "30":
      return {
        title: "Έξυπνα παγκάκια",
        // tooltip: "",
        bgColor: "#A9DE31",
        icon: "im-icon-Battery-Charge",
        mapContent: ["address", "address"],
        size: "large",
        mapOnTile: true,
      };
    case "31":
      // console.log("categoryId", categoryId);
      return {
        title: "Πινακίδες πληροφόρησης", //ηλιακοί φορτιστες
        // tooltip: "",
        bgColor: "#DE31A9",
        icon: "im-icon-Monitor-Vertical",
        mapContent: ["address", "address"],
        size: "large",
        mapOnTile: true,
      };
    case "32":
      return {
        title: "Έξυπνες διαβάσεις",
        // tooltip: "",
        bgColor: "#31A9DE",
        icon: "im-icon-Traffic-Light2",
        mapContent: ["address", "address"],
        size: "large",
        mapOnTile: true,
      };
    case "33":
      return {
        title: "Παρκόμετρα",
        // tooltip: "",
        bgColor: "#8c6de8",
        icon: "im-icon-Timer-2",
        mapContent: ["title"],
        size: "large",
        mapOnTile: true,
      };
    case "34":
      return {
        title: "Κολωνάκια",
        // tooltip: "",
        bgColor: "#065DFB",
        icon: "im-icon-Button",
        mapContent: ["address"], // prefix: Κολωνάκι
        size: "large",
        mapOnTile: true,
      };
    case "122a":
      return {
        header: {
          title: "Διαδρομές ΑΜΕΑ",

          bgColor: "#27AAE1",
        },
        content: {
          items: {
            routes: ["name", "type"],
            infra: [["category", "title"], "type"],
          },
          icon: "im-icon-Truck",
        },
        map: {
          title: "ΑΜΕΑ", // prefix ==> routes: "διαδρομές", infra: "Υποδομές"
          bgColor: "#27AAE1",
          ItemContent: {
            routes: ["name", "type"],
            infra: [["category", "title"], "type"],
          },
        },
      };
    case "122":
      return {
        title: "Υποδομές ΑΜΕΑ",
        // tooltip: "",
        mapTitle: "ΑΜΕΑ", // prefix ==> routes: "διαδρομές", infra: "Υποδομές"
        bgColor: "#27AAE1",
        icon: "im-icon-Truck",
        mapContent: {
          routes: ["name", "type"],
          infra: [["category", "title"], "type"],
        },
        size: "large",
        mapOnTile: true,
      };
    default:
      return null;
  }
};

export const activeData = {
  states: [
    "meteo",
    "environment",
    "info",
    "weather",
    "indexes",
    "all",
    "sensorTypes",
    "parking",
    "publicParking",
    "mesh",
    "variables",
    "mobility",
    "hydro",
    // "bins",
    // "environment",
    // "hotSpots",
    // "fleet",
    // "hum",
    // "energy",
  ],

  maps: [
    "meteo",
    "environment",
    "info",
    // "amea",
    // "bins",
    "parking",
    "wifi",
    "hydro",
    "mesh",
    "mobility",
  ],
};

export const citySensorTypes = [
  {
    sensortype_id: "1",
    sensortype_name: "Περιβαλλοντικά Δεδομένα",
    temp_name: "envi",
  },
  {
    sensortype_id: "2",
    sensortype_name: "Δεδομένα Συνάθροισης Κοινού",
    temp_name: "gathering",
  },
  {
    sensortype_id: "4",
    sensortype_name: "WiFi Hotspots",
    temp_name: "wifi",
  },
  {
    sensortype_id: "5",
    sensortype_name: "Μετεωρολογικά Δεδομένα",
    temp_name: "meteo",
  },
  {
    sensortype_id: "24",
    sensortype_name: "Αισθητήρες στάθμευσης",
    temp_name: "parking",
  },
  {
    sensortype_id: "30",
    sensortype_name: "Έξυπνα παγκάκια",
    temp_name: "benches",
  },
  {
    sensortype_id: "31",
    sensortype_name: "Πινακίδες πληροφόρησης",
    temp_name: "info",
  },
  {
    sensortype_id: "32",
    sensortype_name: "Έξυπνες διαβάσεις",
    temp_name: "crossing",
  },
  {
    sensortype_id: "36",
    sensortype_name: "Δημόσια χώροι στάθμευσης",
    temp_name: "publicParking",
  },
  {
    sensortype_id: "122",
    sensortype_name: "Υποδομές ΑΜΕΑ",
    temp_name: "amea",
  },
];

export const StepsColumns = [
  {
    title: "Icon",
    dataIndex: "icon",
    key: "icon",
    width: "60px",
  },
  {
    title: "Infrastructure",
    dataIndex: "infrastructure",
    key: "infrastructure",
    width: "300px",
  },
  {
    title: "Action",
    dataIndex: "action",
    key: "action",
  },
];

export const handleLogin = () => {
  const isDEV = window.location.href.includes("localhost");
  const params = new URLSearchParams({
    client_id: isDEV
      ? process.env.REACT_APP_DEV_CLIENT_ID
      : process.env.REACT_APP_PROD_CLIENT_ID,
    redirect_uri: isDEV
      ? process.env.REACT_APP_DEV_REDIRECT_URI
      : process.env.REACT_APP_PROD_REDIRECT_URI,
    scope: "citizen",
    response_type: "code",
  });
  window.location.href = `${process.env.REACT_APP_BASE_URL}/oauth/authorize?${params}`;
};

export const handleLogout = (token) => {
  const isDEV = window.location.href.includes("localhost");
  const params = new URLSearchParams({
    redirect_uri: isDEV
      ? process.env.REACT_APP_DEV_REDIRECT_URI
      : process.env.REACT_APP_PROD_REDIRECT_URI,
    access_token: token,
  });
  localStorage.removeItem("user");
  localStorage.setItem(
    "url",
    `${process.env.REACT_APP_BASE_URL}/api/users/logout?${params}`
  );

  window.location.href = `${process.env.REACT_APP_BASE_URL}/api/users/logout?${params}`;
};

export const inputValidation = (inputType, value, initialValue) => {
  const getInputName = (input) => {
    switch (input) {
      case "name":
        return "όνομα";
      case "surname":
        return "επώνυμο";
      case "address":
        return "διεύθυνση";
      default:
        return "";
    }
  };

  let valid = true;
  let errorMessage = null;
  switch (inputType) {
    case "name":
    case "surname":
    case "address":
      if (value.length < 3) {
        valid = false;
        errorMessage = `Το ${getInputName(
          inputType
        )} πρέπει να έχει περισσότερους από 3 χαρακτήρες`;
      } else if (!/^[A-Za-zΑ-Ωα-ωίϊΐόάέύϋΰήώ0-9\s]+$/.test(value)) {
        valid = false;
        errorMessage = `Το ${getInputName(
          inputType
        )} μπορεί να περιέχει μόνο γράμματα, αριθμούς`;
      } else {
        valid = true;
        errorMessage = null;
      }
      break;
    case "email":
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      if (!emailRegex.test(value)) {
        valid = false;
        errorMessage = "Το Email δεν είναι σωστό";
      } else {
        valid = true;
        errorMessage = null;
      }
      break;
    case "password":
      if (value.length < 8) {
        valid = false;
        errorMessage = "Ο Κωδικός πρέπει να έχει τουλάχιστον 8 χαρακτήρες";
      } else if (!/(?=.*[a-z])/.test(value)) {
        valid = false;
        errorMessage = "Ο Κωδικός πρέπει να έχει τουλάχιστον 1 πεζό χαρακτήρα";
      } else if (!/(?=.*[A-Z])/.test(value)) {
        valid = false;
        errorMessage =
          "Ο Κωδικός πρέπει να έχει τουλάχιστον 1 κεφαλαίο χαρακτήρα";
      } else if (!/(?=.*\d)/.test(value)) {
        valid = false;
        errorMessage = "Ο Κωδικός πρέπει να έχει τουλάχιστον 1 αριθμό";
      } else {
        valid = true;
        errorMessage = null;
      }
      break;
    case "verifyPassword":
      if (!value) {
        valid = false;
        errorMessage = "Επιβεβαιώστε τον Κωδικό";
      } else if (value !== initialValue) {
        valid = false;
        errorMessage = "Οι κωδικοί δεν ταιριάζουν";
      } else {
        valid = true;
        errorMessage = null;
      }

      break;
    default:
      break;
  }
  return errorMessage;
  // return {
  //   valid,
  //   errorMessage,
  // };
};

export const powerData = [
  {
    mysensor_id: "183",
    ref_id: "183",
    mysensor_name: "HAM1",
    sensor_description: null,
    sensor_address: "HAM1",
    location_id: null,
    sensortype_id: "12",
    lat: "39.0758619",
    lng: "21.022196",
    latlng: "21.022196,21.022196",
    location_name: null,
    location_lat: null,
    location_lng: null,
    sensortype_name: "Κατανάλωση ενέργειας",
    sensortype_color: "#cb6de9",
    sensortype_icon: "im im-icon-On-Off-3",
    sensortype_description: null,
    marker: "",
    group: null,
    group_name: null,
    metrics: [
      {
        content: "Κατάσταση",
        value: "Ενεργό",
      },
    ],
  },
  {
    mysensor_id: "184",
    ref_id: "184",
    mysensor_name: "HAM2",
    sensor_description: null,
    sensor_address: "HAM2",
    location_id: null,
    sensortype_id: "12",
    lat: "39.0758619",
    lng: "21.022196",
    latlng: "21.022196,21.022196",
    location_name: null,
    location_lat: null,
    location_lng: null,
    sensortype_name: "Κατανάλωση ενέργειας",
    sensortype_color: "#cb6de9",
    sensortype_icon: "im im-icon-On-Off-3",
    sensortype_description: null,
    marker: "",
    group: null,
    group_name: null,
    metrics: [
      {
        content: "Κατάσταση",
        value: "Ενεργό",
      },
    ],
  },

  {
    mysensor_id: "313",
    ref_id: "313",
    mysensor_name: "Κομμένο Κεντρ. παροχή Κοινότητας",
    sensor_description: null,
    sensor_address: null,
    location_id: null,
    sensortype_id: "12",
    lat: "39.046012595913",
    lng: "21.030269621624",
    latlng: "21.030269621624,21.030269621624",
    location_name: null,
    location_lat: null,
    location_lng: null,
    sensortype_name: "Κατανάλωση ενέργειας",
    sensortype_color: "#cb6de9",
    sensortype_icon: "im im-icon-On-Off-3",
    sensortype_description: null,
    marker: "",
    group: null,
    group_name: null,
    metrics: [
      {
        content: "Κατάσταση",
        value: "Ενεργό",
      },
    ],
  },
  {
    mysensor_id: "314",
    ref_id: "314",
    mysensor_name: "Νεοχώρι Παιδικός Στ Κλιματιστικό",
    sensor_description: null,
    sensor_address: null,
    location_id: null,
    sensortype_id: "12",
    lat: "39.070511571102",
    lng: "21.01824420648",
    latlng: "21.01824420648,21.01824420648",
    location_name: null,
    location_lat: null,
    location_lng: null,
    sensortype_name: "Κατανάλωση ενέργειας",
    sensortype_color: "#cb6de9",
    sensortype_icon: "im im-icon-On-Off-3",
    sensortype_description: null,
    marker: "",
    group: null,
    group_name: null,
    metrics: [
      {
        content: "Κατάσταση",
        value: "Ενεργό",
      },
    ],
  },
  {
    mysensor_id: "315",
    ref_id: "315",
    mysensor_name: "Πέτα Δημαρχείο Πλατεία",
    sensor_description: null,
    sensor_address: null,
    location_id: null,
    sensortype_id: "12",
    lat: "39.166898990415",
    lng: "21.034795582327",
    latlng: "21.034795582327,21.034795582327",
    location_name: null,
    location_lat: null,
    location_lng: null,
    sensortype_name: "Κατανάλωση ενέργειας",
    sensortype_color: "#cb6de9",
    sensortype_icon: "im im-icon-On-Off-3",
    sensortype_description: null,
    marker: "",
    group: null,
    group_name: null,
    metrics: [
      {
        content: "Κατάσταση",
        value: "Ενεργό",
      },
    ],
  },
  {
    mysensor_id: "316",
    ref_id: "316",
    mysensor_name: "Πέτα Δημαρχείο Κεντρική Παροχή",
    sensor_description: null,
    sensor_address: null,
    location_id: null,
    sensortype_id: "12",
    lat: "39.166805410958",
    lng: "21.034752666983",
    latlng: "21.034752666983,21.034752666983",
    location_name: null,
    location_lat: null,
    location_lng: null,
    sensortype_name: "Κατανάλωση ενέργειας",
    sensortype_color: "#cb6de9",
    sensortype_icon: "im im-icon-On-Off-3",
    sensortype_description: null,
    marker: "",
    group: null,
    group_name: null,
    metrics: [
      {
        content: "Κατάσταση",
        value: "Ενεργό",
      },
    ],
  },
  {
    mysensor_id: "317",
    ref_id: "317",
    mysensor_name: "Πέτα Δημαρχείο 1ος ορ.",
    sensor_description: null,
    sensor_address: null,
    location_id: null,
    sensortype_id: "12",
    lat: "39.1668449223",
    lng: "21.034731209311",
    latlng: "21.034731209311,21.034731209311",
    location_name: null,
    location_lat: null,
    location_lng: null,
    sensortype_name: "Κατανάλωση ενέργειας",
    sensortype_color: "#cb6de9",
    sensortype_icon: "im im-icon-On-Off-3",
    sensortype_description: null,
    marker: "",
    group: null,
    group_name: null,
    metrics: [
      {
        content: "Κατάσταση",
        value: "Ενεργό",
      },
    ],
  },
  {
    mysensor_id: "318",
    ref_id: "318",
    mysensor_name: "Πέτα Δημαρχείο Τεχν Υπηρεσία",
    sensor_description: null,
    sensor_address: null,
    location_id: null,
    sensortype_id: "12",
    lat: "39.166847001843",
    lng: "21.034720480475",
    latlng: "21.034720480475,21.034720480475",
    location_name: null,
    location_lat: null,
    location_lng: null,
    sensortype_name: "Κατανάλωση ενέργειας",
    sensortype_color: "#cb6de9",
    sensortype_icon: "im im-icon-On-Off-3",
    sensortype_description: null,
    marker: "",
    group: null,
    group_name: null,
    metrics: [
      {
        content: "Κατάσταση",
        value: "Ενεργό",
      },
    ],
  },
  {
    mysensor_id: "319",
    ref_id: "319",
    mysensor_name: "Κορακοφωλιά 1ος ορ.",
    sensor_description: null,
    sensor_address: null,
    location_id: null,
    sensortype_id: "12",
    lat: "39.176320348858",
    lng: "21.031375229359",
    latlng: "21.031375229359,21.031375229359",
    location_name: null,
    location_lat: null,
    location_lng: null,
    sensortype_name: "Κατανάλωση ενέργειας",
    sensortype_color: "#cb6de9",
    sensortype_icon: "im im-icon-On-Off-3",
    sensortype_description: null,
    marker: "",
    group: null,
    group_name: null,
    metrics: [
      {
        content: "Κατάσταση",
        value: "Ενεργό",
      },
    ],
  },
  {
    mysensor_id: "320",
    ref_id: "320",
    mysensor_name: "Κορακοφωλιά φώτα ισόγειο",
    sensor_description: null,
    sensor_address: null,
    location_id: null,
    sensortype_id: "12",
    lat: "39.176314111067",
    lng: "21.031329631805",
    latlng: "21.031329631805,21.031329631805",
    location_name: null,
    location_lat: null,
    location_lng: null,
    sensortype_name: "Κατανάλωση ενέργειας",
    sensortype_color: "#cb6de9",
    sensortype_icon: "im im-icon-On-Off-3",
    sensortype_description: null,
    marker: "",
    group: null,
    group_name: null,
    metrics: [
      {
        content: "Κατάσταση",
        value: "Ενεργό",
      },
    ],
  },
  {
    mysensor_id: "321",
    ref_id: "321",
    mysensor_name: "Κορακοφωλιά 1ος φώτα",
    sensor_description: null,
    sensor_address: null,
    location_id: null,
    sensortype_id: "12",
    lat: "39.176301635484",
    lng: "21.031329631805",
    latlng: "21.031329631805,21.031329631805",
    location_name: null,
    location_lat: null,
    location_lng: null,
    sensortype_name: "Κατανάλωση ενέργειας",
    sensortype_color: "#cb6de9",
    sensortype_icon: "im im-icon-On-Off-3",
    sensortype_description: null,
    marker: "",
    group: null,
    group_name: null,
    metrics: [
      {
        content: "Κατάσταση",
        value: "Ενεργό",
      },
    ],
  },
  {
    mysensor_id: "322",
    ref_id: "322",
    mysensor_name: "Πέτα Οικον. Υπ. κεντρική",
    sensor_description: null,
    sensor_address: null,
    location_id: null,
    sensortype_id: "12",
    lat: "39.16685116093",
    lng: "21.034688293967",
    latlng: "21.034688293967,21.034688293967",
    location_name: null,
    location_lat: null,
    location_lng: null,
    sensortype_name: "Κατανάλωση ενέργειας",
    sensortype_color: "#cb6de9",
    sensortype_icon: "im im-icon-On-Off-3",
    sensortype_description: null,
    marker: "",
    group: null,
    group_name: null,
    metrics: [
      {
        content: "Κατάσταση",
        value: "Ενεργό",
      },
    ],
  },
  {
    mysensor_id: "323",
    ref_id: "323",
    mysensor_name: "Νεοχώρι Δημαρχείο 1ος όροφος (Β)",
    sensor_description: null,
    sensor_address: null,
    location_id: null,
    sensortype_id: "12",
    lat: "39.072847973153",
    lng: "21.02272081218",
    latlng: "21.02272081218,21.02272081218",
    location_name: null,
    location_lat: null,
    location_lng: null,
    sensortype_name: "Κατανάλωση ενέργειας",
    sensortype_color: "#cb6de9",
    sensortype_icon: "im im-icon-On-Off-3",
    sensortype_description: null,
    marker: "",
    group: null,
    group_name: null,
    metrics: [
      {
        content: "Κατάσταση",
        value: "Ενεργό",
      },
    ],
  },
  {
    mysensor_id: "324",
    ref_id: "324",
    mysensor_name: "Νεοχώρι Παιδικός Στ Θερμοσίφωνας",
    sensor_description: null,
    sensor_address: null,
    location_id: null,
    sensortype_id: "12",
    lat: "39.070576125132",
    lng: "21.018236159853",
    latlng: "21.018236159853,21.018236159853",
    location_name: null,
    location_lat: null,
    location_lng: null,
    sensortype_name: "Κατανάλωση ενέργειας",
    sensortype_color: "#cb6de9",
    sensortype_icon: "im im-icon-On-Off-3",
    sensortype_description: null,
    marker: "",
    group: null,
    group_name: null,
    metrics: [
      {
        content: "Κατάσταση",
        value: "Ενεργό",
      },
    ],
  },
  {
    mysensor_id: "325",
    ref_id: "325",
    mysensor_name: "Νεοχώρι Γυμν-Λύκειο γυμναστήριο",
    sensor_description: null,
    sensor_address: null,
    location_id: null,
    sensortype_id: "12",
    lat: "39.06875526237",
    lng: "21.018617570335",
    latlng: "21.018617570335,21.018617570335",
    location_name: null,
    location_lat: null,
    location_lng: null,
    sensortype_name: "Κατανάλωση ενέργειας",
    sensortype_color: "#cb6de9",
    sensortype_icon: "im im-icon-On-Off-3",
    sensortype_description: null,
    marker: "",
    group: null,
    group_name: null,
    metrics: [
      {
        content: "Κατάσταση",
        value: "Ενεργό",
      },
    ],
  },
  {
    mysensor_id: "326",
    ref_id: "326",
    mysensor_name: "Νεοχώρι Γυμν-Λύκ εργαστ.πληρόφορ",
    sensor_description: null,
    sensor_address: null,
    location_id: null,
    sensortype_id: "12",
    lat: "39.068742767724",
    lng: "21.018695354396",
    latlng: "21.018695354396,21.018695354396",
    location_name: null,
    location_lat: null,
    location_lng: null,
    sensortype_name: "Κατανάλωση ενέργειας",
    sensortype_color: "#cb6de9",
    sensortype_icon: "im im-icon-On-Off-3",
    sensortype_description: null,
    marker: "",
    group: null,
    group_name: null,
    metrics: [
      {
        content: "Κατάσταση",
        value: "Ενεργό",
      },
    ],
  },
  {
    mysensor_id: "327",
    ref_id: "327",
    mysensor_name: "Λουτρότοπος Κοινότητα κεντρική",
    sensor_description: null,
    sensor_address: null,
    location_id: null,
    sensortype_id: "12",
    lat: "39.060257975905",
    lng: "21.037891387678",
    latlng: "21.037891387678,21.037891387678",
    location_name: null,
    location_lat: null,
    location_lng: null,
    sensortype_name: "Κατανάλωση ενέργειας",
    sensortype_color: "#cb6de9",
    sensortype_icon: "im im-icon-On-Off-3",
    sensortype_description: null,
    marker: "",
    group: null,
    group_name: null,
    metrics: [
      {
        content: "Κατάσταση",
        value: "Ενεργό",
      },
    ],
  },
  {
    mysensor_id: "328",
    ref_id: "328",
    mysensor_name: "Νεοχώρι Παιδικός Στ Ισόγειο",
    sensor_description: null,
    sensor_address: null,
    location_id: null,
    sensortype_id: "12",
    lat: "39.070634431947",
    lng: "21.018214702181",
    latlng: "21.018214702181,21.018214702181",
    location_name: null,
    location_lat: null,
    location_lng: null,
    sensortype_name: "Κατανάλωση ενέργειας",
    sensortype_color: "#cb6de9",
    sensortype_icon: "im im-icon-On-Off-3",
    sensortype_description: null,
    marker: "",
    group: null,
    group_name: null,
    metrics: [
      {
        content: "Κατάσταση",
        value: "Ενεργό",
      },
    ],
  },
  {
    mysensor_id: "329",
    ref_id: "329",
    mysensor_name: "Κομμένο Κοινότ. φώτα παιδικής",
    sensor_description: null,
    sensor_address: null,
    location_id: null,
    sensortype_id: "12",
    lat: "39.045829281848",
    lng: "21.030119417919",
    latlng: "21.030119417919,21.030119417919",
    location_name: null,
    location_lat: null,
    location_lng: null,
    sensortype_name: "Κατανάλωση ενέργειας",
    sensortype_color: "#cb6de9",
    sensortype_icon: "im im-icon-On-Off-3",
    sensortype_description: null,
    marker: "",
    group: null,
    group_name: null,
    metrics: [
      {
        content: "Κατάσταση",
        value: "Ενεργό",
      },
    ],
  },
  {
    mysensor_id: "330",
    ref_id: "330",
    mysensor_name: "Ακροποταμιά ταμείο κεντρική",
    sensor_description: null,
    sensor_address: null,
    location_id: null,
    sensortype_id: "12",
    lat: "39.093768024411",
    lng: "21.020750998141",
    latlng: "21.020750998141,21.020750998141",
    location_name: null,
    location_lat: null,
    location_lng: null,
    sensortype_name: "Κατανάλωση ενέργειας",
    sensortype_color: "#cb6de9",
    sensortype_icon: "im im-icon-On-Off-3",
    sensortype_description: null,
    marker: "",
    group: null,
    group_name: null,
    metrics: [
      {
        content: "Κατάσταση",
        value: "Ενεργό",
      },
    ],
  },
  {
    mysensor_id: "331",
    ref_id: "331",
    mysensor_name: "Κομμένο ΚΕΠ κλιματιστικό",
    sensor_description: null,
    sensor_address: null,
    location_id: null,
    sensortype_id: "12",
    lat: "39.046795841559",
    lng: "21.030119417919",
    latlng: "21.030119417919,21.030119417919",
    location_name: null,
    location_lat: null,
    location_lng: null,
    sensortype_name: "Κατανάλωση ενέργειας",
    sensortype_color: "#cb6de9",
    sensortype_icon: "im im-icon-On-Off-3",
    sensortype_description: null,
    marker: "",
    group: null,
    group_name: null,
    metrics: [
      {
        content: "Κατάσταση",
        value: "Ενεργό",
      },
    ],
  },
  {
    mysensor_id: "332",
    ref_id: "332",
    mysensor_name: "Κομμένο Κοινότ. φώτα πλατείας",
    sensor_description: null,
    sensor_address: null,
    location_id: null,
    sensortype_id: "12",
    lat: "39.046595864773",
    lng: "21.030355452313",
    latlng: "21.030355452313,21.030355452313",
    location_name: null,
    location_lat: null,
    location_lng: null,
    sensortype_name: "Κατανάλωση ενέργειας",
    sensortype_color: "#cb6de9",
    sensortype_icon: "im im-icon-On-Off-3",
    sensortype_description: null,
    marker: "",
    group: null,
    group_name: null,
    metrics: [
      {
        content: "Κατάσταση",
        value: "Ενεργό",
      },
    ],
  },
  {
    mysensor_id: "333",
    ref_id: "333",
    mysensor_name: "Νεοχώρι Παιδικός ηλ. κουζ. μικρή",
    sensor_description: null,
    sensor_address: null,
    location_id: null,
    sensortype_id: "12",
    lat: "39.070538642154",
    lng: "21.01821738439",
    latlng: "21.01821738439,21.01821738439",
    location_name: null,
    location_lat: null,
    location_lng: null,
    sensortype_name: "Κατανάλωση ενέργειας",
    sensortype_color: "#cb6de9",
    sensortype_icon: "im im-icon-On-Off-3",
    sensortype_description: null,
    marker: "",
    group: null,
    group_name: null,
    metrics: [
      {
        content: "Κατάσταση",
        value: "Ενεργό",
      },
    ],
  },
  {
    mysensor_id: "334",
    ref_id: "334",
    mysensor_name: "Νεοχώρι Παιδικός πίνακας κουζίνα",
    sensor_description: null,
    sensor_address: null,
    location_id: null,
    sensortype_id: "12",
    lat: "39.070521983046",
    lng: "21.018233477644",
    latlng: "21.018233477644,21.018233477644",
    location_name: null,
    location_lat: null,
    location_lng: null,
    sensortype_name: "Κατανάλωση ενέργειας",
    sensortype_color: "#cb6de9",
    sensortype_icon: "im im-icon-On-Off-3",
    sensortype_description: null,
    marker: "",
    group: null,
    group_name: null,
    metrics: [
      {
        content: "Κατάσταση",
        value: "Ενεργό",
      },
    ],
  },
  {
    mysensor_id: "335",
    ref_id: "335",
    mysensor_name: "Αγ. Παρασκευή Κοινότητα κεντρική",
    sensor_description: null,
    sensor_address: null,
    location_id: null,
    sensortype_id: "12",
    lat: "39.101041949734",
    lng: "20.983436107636",
    latlng: "20.983436107636,20.983436107636",
    location_name: null,
    location_lat: null,
    location_lng: null,
    sensortype_name: "Κατανάλωση ενέργειας",
    sensortype_color: "#cb6de9",
    sensortype_icon: "im im-icon-On-Off-3",
    sensortype_description: null,
    marker: "",
    group: null,
    group_name: null,
    metrics: [
      {
        content: "Κατάσταση",
        value: "Ενεργό",
      },
    ],
  },
  {
    mysensor_id: "336",
    ref_id: "336",
    mysensor_name: "Αγ. Παρασκευή Κοινότητα κλιματισ",
    sensor_description: null,
    sensor_address: null,
    location_id: null,
    sensortype_id: "12",
    lat: "39.100592346913",
    lng: "20.984637737274",
    latlng: "20.984637737274,20.984637737274",
    location_name: null,
    location_lat: null,
    location_lng: null,
    sensortype_name: "Κατανάλωση ενέργειας",
    sensortype_color: "#cb6de9",
    sensortype_icon: "im im-icon-On-Off-3",
    sensortype_description: null,
    marker: "",
    group: null,
    group_name: null,
    metrics: [
      {
        content: "Κατάσταση",
        value: "Ενεργό",
      },
    ],
  },
  {
    mysensor_id: "337",
    ref_id: "337",
    mysensor_name: "Αμφιθέα Δημοτικό εξωτερ φώτα",
    sensor_description: null,
    sensor_address: null,
    location_id: null,
    sensortype_id: "12",
    lat: "39.130110177259",
    lng: "21.039032936096",
    latlng: "21.039032936096,21.039032936096",
    location_name: null,
    location_lat: null,
    location_lng: null,
    sensortype_name: "Κατανάλωση ενέργειας",
    sensortype_color: "#cb6de9",
    sensortype_icon: "im im-icon-On-Off-3",
    sensortype_description: null,
    marker: "",
    group: null,
    group_name: null,
    metrics: [
      {
        content: "Κατάσταση",
        value: "Ενεργό",
      },
    ],
  },
  {
    mysensor_id: "338",
    ref_id: "338",
    mysensor_name: "Νεοχώρι Δημαρχείο rack",
    sensor_description: null,
    sensor_address: null,
    location_id: null,
    sensortype_id: "12",
    lat: "39.072931265907",
    lng: "21.022398947098",
    latlng: "21.022398947098,21.022398947098",
    location_name: null,
    location_lat: null,
    location_lng: null,
    sensortype_name: "Κατανάλωση ενέργειας",
    sensortype_color: "#cb6de9",
    sensortype_icon: "im im-icon-On-Off-3",
    sensortype_description: null,
    marker: "",
    group: null,
    group_name: null,
    metrics: [
      {
        content: "Κατάσταση",
        value: "Ενεργό",
      },
    ],
  },
  {
    mysensor_id: "339",
    ref_id: "339",
    mysensor_name: "Ανθότοπος Παιδικός κεντρική",
    sensor_description: null,
    sensor_address: null,
    location_id: null,
    sensortype_id: "12",
    lat: "39.107878473473",
    lng: "20.998806774469",
    latlng: "20.998806774469,20.998806774469",
    location_name: null,
    location_lat: null,
    location_lng: null,
    sensortype_name: "Κατανάλωση ενέργειας",
    sensortype_color: "#cb6de9",
    sensortype_icon: "im im-icon-On-Off-3",
    sensortype_description: null,
    marker: "",
    group: null,
    group_name: null,
    metrics: [
      {
        content: "Κατάσταση",
        value: "Ενεργό",
      },
    ],
  },
  {
    mysensor_id: "340",
    ref_id: "340",
    mysensor_name: "Αγ. Δημήτριος Δημοτικό προβολείς",
    sensor_description: null,
    sensor_address: null,
    location_id: null,
    sensortype_id: "12",
    lat: "39.160067778972",
    lng: "21.016596793916",
    latlng: "21.016596793916,21.016596793916",
    location_name: null,
    location_lat: null,
    location_lng: null,
    sensortype_name: "Κατανάλωση ενέργειας",
    sensortype_color: "#cb6de9",
    sensortype_icon: "im im-icon-On-Off-3",
    sensortype_description: null,
    marker: "",
    group: null,
    group_name: null,
    metrics: [
      {
        content: "Κατάσταση",
        value: "Ενεργό",
      },
    ],
  },
  {
    mysensor_id: "341",
    ref_id: "341",
    mysensor_name: "Πέτα παιδικός κεντρική",
    sensor_description: null,
    sensor_address: null,
    location_id: null,
    sensortype_id: "12",
    lat: "39.175370119001",
    lng: "21.034280061722",
    latlng: "21.034280061722,21.034280061722",
    location_name: null,
    location_lat: null,
    location_lng: null,
    sensortype_name: "Κατανάλωση ενέργειας",
    sensortype_color: "#cb6de9",
    sensortype_icon: "im im-icon-On-Off-3",
    sensortype_description: null,
    marker: "",
    group: null,
    group_name: null,
    metrics: [
      {
        content: "Κατάσταση",
        value: "Ενεργό",
      },
    ],
  },
  {
    mysensor_id: "342",
    ref_id: "342",
    mysensor_name: "Πέτα παιδικός μαγειρείο",
    sensor_description: null,
    sensor_address: null,
    location_id: null,
    sensortype_id: "12",
    lat: "39.175228727028",
    lng: "21.034601926804",
    latlng: "21.034601926804,21.034601926804",
    location_name: null,
    location_lat: null,
    location_lng: null,
    sensortype_name: "Κατανάλωση ενέργειας",
    sensortype_color: "#cb6de9",
    sensortype_icon: "im im-icon-On-Off-3",
    sensortype_description: null,
    marker: "",
    group: null,
    group_name: null,
    metrics: [
      {
        content: "Κατάσταση",
        value: "Ενεργό",
      },
    ],
  },
  {
    mysensor_id: "343",
    ref_id: "343",
    mysensor_name: "Νεοχώρι Δημοτικό γυμναστήριο",
    sensor_description: null,
    sensor_address: null,
    location_id: null,
    sensortype_id: "12",
    lat: "39.070602779911",
    lng: "21.017496943277",
    latlng: "21.017496943277,21.017496943277",
    location_name: null,
    location_lat: null,
    location_lng: null,
    sensortype_name: "Κατανάλωση ενέργειας",
    sensortype_color: "#cb6de9",
    sensortype_icon: "im im-icon-On-Off-3",
    sensortype_description: null,
    marker: "",
    group: null,
    group_name: null,
    metrics: [
      {
        content: "Κατάσταση",
        value: "Ενεργό",
      },
    ],
  },
  {
    mysensor_id: "344",
    ref_id: "344",
    mysensor_name: "Νεοχώρι Δημοτικό τμ. ένταξης",
    sensor_description: null,
    sensor_address: null,
    location_id: null,
    sensortype_id: "12",
    lat: "39.070640262854",
    lng: "21.017454027933",
    latlng: "21.017454027933,21.017454027933",
    location_name: null,
    location_lat: null,
    location_lng: null,
    sensortype_name: "Κατανάλωση ενέργειας",
    sensortype_color: "#cb6de9",
    sensortype_icon: "im im-icon-On-Off-3",
    sensortype_description: null,
    marker: "",
    group: null,
    group_name: null,
    metrics: [
      {
        content: "Κατάσταση",
        value: "Ενεργό",
      },
    ],
  },
  {
    mysensor_id: "345",
    ref_id: "345",
    mysensor_name: "Πέτα παιδικός κλιματιστικό",
    sensor_description: null,
    sensor_address: null,
    location_id: null,
    sensortype_id: "12",
    lat: "39.175569730715",
    lng: "21.03431224823",
    latlng: "21.03431224823,21.03431224823",
    location_name: null,
    location_lat: null,
    location_lng: null,
    sensortype_name: "Κατανάλωση ενέργειας",
    sensortype_color: "#cb6de9",
    sensortype_icon: "im im-icon-On-Off-3",
    sensortype_description: null,
    marker: "",
    group: null,
    group_name: null,
    metrics: [
      {
        content: "Κατάσταση",
        value: "Ενεργό",
      },
    ],
  },
  {
    mysensor_id: "346",
    ref_id: "346",
    mysensor_name: "Αγ. Παρασκευή Νηπιαγωγίο κεντρικ",
    sensor_description: null,
    sensor_address: null,
    location_id: null,
    sensortype_id: "12",
    lat: "39.097944627695",
    lng: "20.99006652832",
    latlng: "20.99006652832,20.99006652832",
    location_name: null,
    location_lat: null,
    location_lng: null,
    sensortype_name: "Κατανάλωση ενέργειας",
    sensortype_color: "#cb6de9",
    sensortype_icon: "im im-icon-On-Off-3",
    sensortype_description: null,
    marker: "",
    group: null,
    group_name: null,
    metrics: [
      {
        content: "Κατάσταση",
        value: "Ενεργό",
      },
    ],
  },
  {
    mysensor_id: "347",
    ref_id: "347",
    mysensor_name: "Αγ. Δημήτριος Δημοτικό ισόγειο",
    sensor_description: null,
    sensor_address: null,
    location_id: null,
    sensortype_id: "12",
    lat: "39.160007466368",
    lng: "21.016553878571",
    latlng: "21.016553878571,21.016553878571",
    location_name: null,
    location_lat: null,
    location_lng: null,
    sensortype_name: "Κατανάλωση ενέργειας",
    sensortype_color: "#cb6de9",
    sensortype_icon: "im im-icon-On-Off-3",
    sensortype_description: null,
    marker: "",
    group: null,
    group_name: null,
    metrics: [
      {
        content: "Κατάσταση",
        value: "Ενεργό",
      },
    ],
  },
  {
    mysensor_id: "348",
    ref_id: "348",
    mysensor_name: "Κομπότι Δημοτικό κεντρική",
    sensor_description: null,
    sensor_address: null,
    location_id: null,
    sensortype_id: "12",
    lat: "39.102101835244",
    lng: "21.085362195608",
    latlng: "21.085362195608,21.085362195608",
    location_name: null,
    location_lat: null,
    location_lng: null,
    sensortype_name: "Κατανάλωση ενέργειας",
    sensortype_color: "#cb6de9",
    sensortype_icon: "im im-icon-On-Off-3",
    sensortype_description: null,
    marker: "",
    group: null,
    group_name: null,
    metrics: [
      {
        content: "Κατάσταση",
        value: "Ενεργό",
      },
    ],
  },
  {
    mysensor_id: "349",
    ref_id: "349",
    mysensor_name: "Κομπότι Δημοτικό εξωτ. αίθουσες",
    sensor_description: null,
    sensor_address: null,
    location_id: null,
    sensortype_id: "12",
    lat: "39.102172604733",
    lng: "21.085461437342",
    latlng: "21.085461437342,21.085461437342",
    location_name: null,
    location_lat: null,
    location_lng: null,
    sensortype_name: "Κατανάλωση ενέργειας",
    sensortype_color: "#cb6de9",
    sensortype_icon: "im im-icon-On-Off-3",
    sensortype_description: null,
    marker: "",
    group: null,
    group_name: null,
    metrics: [
      {
        content: "Κατάσταση",
        value: "Ενεργό",
      },
    ],
  },
  {
    mysensor_id: "350",
    ref_id: "350",
    mysensor_name: "Κομπότι Δημοτικό κυλικείο",
    sensor_description: null,
    sensor_address: null,
    location_id: null,
    sensortype_id: "12",
    lat: "39.102056043183",
    lng: "21.085233449576",
    latlng: "21.085233449576,21.085233449576",
    location_name: null,
    location_lat: null,
    location_lng: null,
    sensortype_name: "Κατανάλωση ενέργειας",
    sensortype_color: "#cb6de9",
    sensortype_icon: "im im-icon-On-Off-3",
    sensortype_description: null,
    marker: "",
    group: null,
    group_name: null,
    metrics: [
      {
        content: "Κατάσταση",
        value: "Ενεργό",
      },
    ],
  },
  {
    mysensor_id: "351",
    ref_id: "351",
    mysensor_name: "Νεοχώρι Δημοτικό κεντρική",
    sensor_description: null,
    sensor_address: null,
    location_id: null,
    sensortype_id: "12",
    lat: "39.070733970127",
    lng: "21.017529129786",
    latlng: "21.017529129786,21.017529129786",
    location_name: null,
    location_lat: null,
    location_lng: null,
    sensortype_name: "Κατανάλωση ενέργειας",
    sensortype_color: "#cb6de9",
    sensortype_icon: "im im-icon-On-Off-3",
    sensortype_description: null,
    marker: "",
    group: null,
    group_name: null,
    metrics: [
      {
        content: "Κατάσταση",
        value: "Ενεργό",
      },
    ],
  },
  {
    mysensor_id: "352",
    ref_id: "352",
    mysensor_name: "Νεοχώρι Δημοτικό εξωτ.φώτα παλιά",
    sensor_description: null,
    sensor_address: null,
    location_id: null,
    sensortype_id: "12",
    lat: "39.070677745778",
    lng: "21.017547905249",
    latlng: "21.017547905249,21.017547905249",
    location_name: null,
    location_lat: null,
    location_lng: null,
    sensortype_name: "Κατανάλωση ενέργειας",
    sensortype_color: "#cb6de9",
    sensortype_icon: "im im-icon-On-Off-3",
    sensortype_description: null,
    marker: "",
    group: null,
    group_name: null,
    metrics: [
      {
        content: "Κατάσταση",
        value: "Ενεργό",
      },
    ],
  },
  {
    mysensor_id: "353",
    ref_id: "353",
    mysensor_name: "Νεοχώρι Νηπιαγωγείο",
    sensor_description: null,
    sensor_address: null,
    location_id: null,
    sensortype_id: "12",
    lat: "39.070677745778",
    lng: "21.017791986269",
    latlng: "21.017791986269,21.017791986269",
    location_name: null,
    location_lat: null,
    location_lng: null,
    sensortype_name: "Κατανάλωση ενέργειας",
    sensortype_color: "#cb6de9",
    sensortype_icon: "im im-icon-On-Off-3",
    sensortype_description: null,
    marker: "",
    group: null,
    group_name: null,
    metrics: [
      {
        content: "Κατάσταση",
        value: "Ενεργό",
      },
    ],
  },
  {
    mysensor_id: "354",
    ref_id: "354",
    mysensor_name: "Αμφιθέα Δημοτικό κεντρική",
    sensor_description: null,
    sensor_address: null,
    location_id: null,
    sensortype_id: "12",
    lat: "39.129877146379",
    lng: "21.039805412292",
    latlng: "21.039805412292,21.039805412292",
    location_name: null,
    location_lat: null,
    location_lng: null,
    sensortype_name: "Κατανάλωση ενέργειας",
    sensortype_color: "#cb6de9",
    sensortype_icon: "im im-icon-On-Off-3",
    sensortype_description: null,
    marker: "",
    group: null,
    group_name: null,
    metrics: [
      {
        content: "Κατάσταση",
        value: "Ενεργό",
      },
    ],
  },
  {
    mysensor_id: "355",
    ref_id: "355",
    mysensor_name: "Κορακοφωλιά διάδρομος",
    sensor_description: null,
    sensor_address: null,
    location_id: null,
    sensortype_id: "12",
    lat: "39.176251733128",
    lng: "21.031281352043",
    latlng: "21.031281352043,21.031281352043",
    location_name: null,
    location_lat: null,
    location_lng: null,
    sensortype_name: "Κατανάλωση ενέργειας",
    sensortype_color: "#cb6de9",
    sensortype_icon: "im im-icon-On-Off-3",
    sensortype_description: null,
    marker: "",
    group: null,
    group_name: null,
    metrics: [
      {
        content: "Κατάσταση",
        value: "Ενεργό",
      },
    ],
  },
  {
    mysensor_id: "356",
    ref_id: "356",
    mysensor_name: "Κορακοφωλιά κουζίνες & WC ΑΜΕΑ",
    sensor_description: null,
    sensor_address: null,
    location_id: null,
    sensortype_id: "12",
    lat: "39.176316190331",
    lng: "21.031294763088",
    latlng: "21.031294763088,21.031294763088",
    location_name: null,
    location_lat: null,
    location_lng: null,
    sensortype_name: "Κατανάλωση ενέργειας",
    sensortype_color: "#cb6de9",
    sensortype_icon: "im im-icon-On-Off-3",
    sensortype_description: null,
    marker: "",
    group: null,
    group_name: null,
    metrics: [
      {
        content: "Κατάσταση",
        value: "Ενεργό",
      },
    ],
  },
  {
    mysensor_id: "357",
    ref_id: "357",
    mysensor_name: "Λουτρότοπος Κοινότητα κλιματιστ",
    sensor_description: null,
    sensor_address: null,
    location_id: null,
    sensortype_id: "12",
    lat: "39.060158006642",
    lng: "21.037891387678",
    latlng: "21.037891387678,21.037891387678",
    location_name: null,
    location_lat: null,
    location_lng: null,
    sensortype_name: "Κατανάλωση ενέργειας",
    sensortype_color: "#cb6de9",
    sensortype_icon: "im im-icon-On-Off-3",
    sensortype_description: null,
    marker: "",
    group: null,
    group_name: null,
    metrics: [
      {
        content: "Κατάσταση",
        value: "Ενεργό",
      },
    ],
  },
  {
    mysensor_id: "358",
    ref_id: "358",
    mysensor_name: "Κορακοφωλιά ισόγειο",
    sensor_description: null,
    sensor_address: null,
    location_id: null,
    sensortype_id: "12",
    lat: "39.176330745175",
    lng: "21.031332314014",
    latlng: "21.031332314014,21.031332314014",
    location_name: null,
    location_lat: null,
    location_lng: null,
    sensortype_name: "Κατανάλωση ενέργειας",
    sensortype_color: "#cb6de9",
    sensortype_icon: "im im-icon-On-Off-3",
    sensortype_description: null,
    marker: "",
    group: null,
    group_name: null,
    metrics: [
      {
        content: "Κατάσταση",
        value: "Ενεργό",
      },
    ],
  },
  {
    mysensor_id: "359",
    ref_id: "359",
    mysensor_name: "Αμφιθέα Παιδικός",
    sensor_description: null,
    sensor_address: null,
    location_id: null,
    sensortype_id: "12",
    lat: "39.12951095344",
    lng: "21.039183139801",
    latlng: "21.039183139801,21.039183139801",
    location_name: null,
    location_lat: null,
    location_lng: null,
    sensortype_name: "Κατανάλωση ενέργειας",
    sensortype_color: "#cb6de9",
    sensortype_icon: "im im-icon-On-Off-3",
    sensortype_description: null,
    marker: "",
    group: null,
    group_name: null,
    metrics: [
      {
        content: "Κατάσταση",
        value: "Ενεργό",
      },
    ],
  },
  {
    mysensor_id: "360",
    ref_id: "360",
    mysensor_name: "Κορακοφωλιά αιθ. συμβουλίου",
    sensor_description: null,
    sensor_address: null,
    location_id: null,
    sensortype_id: "12",
    lat: "39.176320348858",
    lng: "21.031227707863",
    latlng: "21.031227707863,21.031227707863",
    location_name: null,
    location_lat: null,
    location_lng: null,
    sensortype_name: "Κατανάλωση ενέργειας",
    sensortype_color: "#cb6de9",
    sensortype_icon: "im im-icon-On-Off-3",
    sensortype_description: null,
    marker: "",
    group: null,
    group_name: null,
    metrics: [
      {
        content: "Κατάσταση",
        value: "Ενεργό",
      },
    ],
  },
  {
    mysensor_id: "361",
    ref_id: "361",
    mysensor_name: "Κομπότι Λύκειο όροφος Ν.1",
    sensor_description: null,
    sensor_address: null,
    location_id: null,
    sensortype_id: "12",
    lat: "39.104147461288",
    lng: "21.079523563385",
    latlng: "21.079523563385,21.079523563385",
    location_name: null,
    location_lat: null,
    location_lng: null,
    sensortype_name: "Κατανάλωση ενέργειας",
    sensortype_color: "#cb6de9",
    sensortype_icon: "im im-icon-On-Off-3",
    sensortype_description: null,
    marker: "",
    group: null,
    group_name: null,
    metrics: [
      {
        content: "Κατάσταση",
        value: "Ενεργό",
      },
    ],
  },
  {
    mysensor_id: "362",
    ref_id: "362",
    mysensor_name: "Νεοχώρι Δημαρχείο ισόγειο",
    sensor_description: null,
    sensor_address: null,
    location_id: null,
    sensortype_id: "12",
    lat: "39.072464825219",
    lng: "21.022806642868",
    latlng: "21.022806642868,21.022806642868",
    location_name: null,
    location_lat: null,
    location_lng: null,
    sensortype_name: "Κατανάλωση ενέργειας",
    sensortype_color: "#cb6de9",
    sensortype_icon: "im im-icon-On-Off-3",
    sensortype_description: null,
    marker: "",
    group: null,
    group_name: null,
    metrics: [
      {
        content: "Κατάσταση",
        value: "Ενεργό",
      },
    ],
  },
  {
    mysensor_id: "363",
    ref_id: "363",
    mysensor_name: "Κορακοφωλιά ανελκυστήρας",
    sensor_description: null,
    sensor_address: null,
    location_id: null,
    sensortype_id: "12",
    lat: "39.176249653863",
    lng: "21.031284034252",
    latlng: "21.031284034252,21.031284034252",
    location_name: null,
    location_lat: null,
    location_lng: null,
    sensortype_name: "Κατανάλωση ενέργειας",
    sensortype_color: "#cb6de9",
    sensortype_icon: "im im-icon-On-Off-3",
    sensortype_description: null,
    marker: "",
    group: null,
    group_name: null,
    metrics: [
      {
        content: "Κατάσταση",
        value: "Ενεργό",
      },
    ],
  },
  {
    mysensor_id: "364",
    ref_id: "364",
    mysensor_name: "Κορακοφωλιά φώτα αίθουσας",
    sensor_description: null,
    sensor_address: null,
    location_id: null,
    sensortype_id: "12",
    lat: "39.176322428122",
    lng: "21.031292080879",
    latlng: "21.031292080879,21.031292080879",
    location_name: null,
    location_lat: null,
    location_lng: null,
    sensortype_name: "Κατανάλωση ενέργειας",
    sensortype_color: "#cb6de9",
    sensortype_icon: "im im-icon-On-Off-3",
    sensortype_description: null,
    marker: "",
    group: null,
    group_name: null,
    metrics: [
      {
        content: "Κατάσταση",
        value: "Ενεργό",
      },
    ],
  },
  {
    mysensor_id: "365",
    ref_id: "365",
    mysensor_name: "Πέτα Γυμνάσιο φώτα γηπέδου",
    sensor_description: null,
    sensor_address: null,
    location_id: null,
    sensortype_id: "12",
    lat: "39.174413222422",
    lng: "21.034189939155",
    latlng: "21.034189939155,21.034189939155",
    location_name: null,
    location_lat: null,
    location_lng: null,
    sensortype_name: "Κατανάλωση ενέργειας",
    sensortype_color: "#cb6de9",
    sensortype_icon: "im im-icon-On-Off-3",
    sensortype_description: null,
    marker: "",
    group: null,
    group_name: null,
    metrics: [
      {
        content: "Κατάσταση",
        value: "Ενεργό",
      },
    ],
  },
  {
    mysensor_id: "366",
    ref_id: "366",
    mysensor_name: "Κομπότι Λύκειο κυλικείο",
    sensor_description: null,
    sensor_address: null,
    location_id: null,
    sensortype_id: "12",
    lat: "39.103831088354",
    lng: "21.079416275024",
    latlng: "21.079416275024,21.079416275024",
    location_name: null,
    location_lat: null,
    location_lng: null,
    sensortype_name: "Κατανάλωση ενέργειας",
    sensortype_color: "#cb6de9",
    sensortype_icon: "im im-icon-On-Off-3",
    sensortype_description: null,
    marker: "",
    group: null,
    group_name: null,
    metrics: [
      {
        content: "Κατάσταση",
        value: "Ενεργό",
      },
    ],
  },
  {
    mysensor_id: "367",
    ref_id: "367",
    mysensor_name: "Κομπότι Γυμνάσιο κυλικείο",
    sensor_description: null,
    sensor_address: null,
    location_id: null,
    sensortype_id: "12",
    lat: "39.104415128155",
    lng: "21.076925575226",
    latlng: "21.076925575226,21.076925575226",
    location_name: null,
    location_lat: null,
    location_lng: null,
    sensortype_name: "Κατανάλωση ενέργειας",
    sensortype_color: "#cb6de9",
    sensortype_icon: "im im-icon-On-Off-3",
    sensortype_description: null,
    marker: "",
    group: null,
    group_name: null,
    metrics: [
      {
        content: "Κατάσταση",
        value: "Ενεργό",
      },
    ],
  },
  {
    mysensor_id: "368",
    ref_id: "368",
    mysensor_name: "Κομπότι Λύκειο κεντρική",
    sensor_description: null,
    sensor_address: null,
    location_id: null,
    sensortype_id: "12",
    lat: "39.103647924427",
    lng: "21.079534292221",
    latlng: "21.079534292221,21.079534292221",
    location_name: null,
    location_lat: null,
    location_lng: null,
    sensortype_name: "Κατανάλωση ενέργειας",
    sensortype_color: "#cb6de9",
    sensortype_icon: "im im-icon-On-Off-3",
    sensortype_description: null,
    marker: "",
    group: null,
    group_name: null,
    metrics: [
      {
        content: "Κατάσταση",
        value: "Ενεργό",
      },
    ],
  },
  {
    mysensor_id: "369",
    ref_id: "369",
    mysensor_name: "Κομπότι Γυμνάσιο αίθ. υπολογιστ.",
    sensor_description: null,
    sensor_address: null,
    location_id: null,
    sensortype_id: "12",
    lat: "39.104367256208",
    lng: "21.07694166848",
    latlng: "21.07694166848,21.07694166848",
    location_name: null,
    location_lat: null,
    location_lng: null,
    sensortype_name: "Κατανάλωση ενέργειας",
    sensortype_color: "#cb6de9",
    sensortype_icon: "im im-icon-On-Off-3",
    sensortype_description: null,
    marker: "",
    group: null,
    group_name: null,
    metrics: [
      {
        content: "Κατάσταση",
        value: "Ενεργό",
      },
    ],
  },
  {
    mysensor_id: "370",
    ref_id: "370",
    mysensor_name: "Κορακοφωλιά αντλία θερμότητας",
    sensor_description: null,
    sensor_address: null,
    location_id: null,
    sensortype_id: "12",
    lat: "39.176343220754",
    lng: "21.03131622076",
    latlng: "21.03131622076,21.03131622076",
    location_name: null,
    location_lat: null,
    location_lng: null,
    sensortype_name: "Κατανάλωση ενέργειας",
    sensortype_color: "#cb6de9",
    sensortype_icon: "im im-icon-On-Off-3",
    sensortype_description: null,
    marker: "",
    group: null,
    group_name: null,
    metrics: [
      {
        content: "Κατάσταση",
        value: "Ενεργό",
      },
    ],
  },
  {
    mysensor_id: "371",
    ref_id: "371",
    mysensor_name: "Κομπότι Δημοτικό αιθ. υπολογιστ",
    sensor_description: null,
    sensor_address: null,
    location_id: null,
    sensortype_id: "12",
    lat: "39.102012332553",
    lng: "21.085169076559",
    latlng: "21.085169076559,21.085169076559",
    location_name: null,
    location_lat: null,
    location_lng: null,
    sensortype_name: "Κατανάλωση ενέργειας",
    sensortype_color: "#cb6de9",
    sensortype_icon: "im im-icon-On-Off-3",
    sensortype_description: null,
    marker: "",
    group: null,
    group_name: null,
    metrics: [
      {
        content: "Κατάσταση",
        value: "Ενεργό",
      },
    ],
  },
  {
    mysensor_id: "372",
    ref_id: "372",
    mysensor_name: "Κομπότι Δημαρχείο κεντρική",
    sensor_description: null,
    sensor_address: null,
    location_id: null,
    sensortype_id: "12",
    lat: "39.102285419503",
    lng: "21.083986222548",
    latlng: "21.083986222548,21.083986222548",
    location_name: null,
    location_lat: null,
    location_lng: null,
    sensortype_name: "Κατανάλωση ενέργειας",
    sensortype_color: "#cb6de9",
    sensortype_icon: "im im-icon-On-Off-3",
    sensortype_description: null,
    marker: "",
    group: null,
    group_name: null,
    metrics: [
      {
        content: "Κατάσταση",
        value: "Ενεργό",
      },
    ],
  },
  {
    mysensor_id: "373",
    ref_id: "373",
    mysensor_name: "Πέτα Δημοτικό κεντρική",
    sensor_description: null,
    sensor_address: null,
    location_id: null,
    sensortype_id: "12",
    lat: "39.165338900843",
    lng: "21.031819939744",
    latlng: "21.031819939744,21.031819939744",
    location_name: null,
    location_lat: null,
    location_lng: null,
    sensortype_name: "Κατανάλωση ενέργειας",
    sensortype_color: "#cb6de9",
    sensortype_icon: "im im-icon-On-Off-3",
    sensortype_description: null,
    marker: "",
    group: null,
    group_name: null,
    metrics: [
      {
        content: "Κατάσταση",
        value: "Ενεργό",
      },
    ],
  },
  {
    mysensor_id: "374",
    ref_id: "374",
    mysensor_name: "Κομπότι Γυμνάσιο κεντρική",
    sensor_description: null,
    sensor_address: null,
    location_id: null,
    sensortype_id: "12",
    lat: "39.104344360917",
    lng: "21.076871931045",
    latlng: "21.076871931045,21.076871931045",
    location_name: null,
    location_lat: null,
    location_lng: null,
    sensortype_name: "Κατανάλωση ενέργειας",
    sensortype_color: "#cb6de9",
    sensortype_icon: "im im-icon-On-Off-3",
    sensortype_description: null,
    marker: "",
    group: null,
    group_name: null,
    metrics: [
      {
        content: "Κατάσταση",
        value: "Ενεργό",
      },
    ],
  },
  {
    mysensor_id: "375",
    ref_id: "375",
    mysensor_name: "Κομμένο Κοινότ. φώτα μνημείου",
    sensor_description: null,
    sensor_address: null,
    location_id: null,
    sensortype_id: "12",
    lat: "39.04559597235",
    lng: "21.030612944378",
    latlng: "21.030612944378,21.030612944378",
    location_name: null,
    location_lat: null,
    location_lng: null,
    sensortype_name: "Κατανάλωση ενέργειας",
    sensortype_color: "#cb6de9",
    sensortype_icon: "im im-icon-On-Off-3",
    sensortype_description: null,
    marker: "",
    group: null,
    group_name: null,
    metrics: [
      {
        content: "Κατάσταση",
        value: "Ενεργό",
      },
    ],
  },
  {
    mysensor_id: "376",
    ref_id: "376",
    mysensor_name: "Κομπότι Δημαρχείο προβολείς",
    sensor_description: null,
    sensor_address: null,
    location_id: null,
    sensortype_id: "12",
    lat: "39.102291663857",
    lng: "21.084002315802",
    latlng: "21.084002315802,21.084002315802",
    location_name: null,
    location_lat: null,
    location_lng: null,
    sensortype_name: "Κατανάλωση ενέργειας",
    sensortype_color: "#cb6de9",
    sensortype_icon: "im im-icon-On-Off-3",
    sensortype_description: null,
    marker: "",
    group: null,
    group_name: null,
    metrics: [
      {
        content: "Κατάσταση",
        value: "Ενεργό",
      },
    ],
  },
  {
    mysensor_id: "377",
    ref_id: "377",
    mysensor_name: "Κομπότι ΚΕΠ",
    sensor_description: null,
    sensor_address: null,
    location_id: null,
    sensortype_id: "12",
    lat: "39.102308315463",
    lng: "21.08397817592",
    latlng: "21.08397817592,21.08397817592",
    location_name: null,
    location_lat: null,
    location_lng: null,
    sensortype_name: "Κατανάλωση ενέργειας",
    sensortype_color: "#cb6de9",
    sensortype_icon: "im im-icon-On-Off-3",
    sensortype_description: null,
    marker: "",
    group: null,
    group_name: null,
    metrics: [
      {
        content: "Κατάσταση",
        value: "Ενεργό",
      },
    ],
  },
  {
    mysensor_id: "378",
    ref_id: "378",
    mysensor_name: "Κορακοφωλιά κολώνες δρόμου",
    sensor_description: null,
    sensor_address: null,
    location_id: null,
    sensortype_id: "12",
    lat: "39.176314111067",
    lng: "21.031278669834",
    latlng: "21.031278669834,21.031278669834",
    location_name: null,
    location_lat: null,
    location_lng: null,
    sensortype_name: "Κατανάλωση ενέργειας",
    sensortype_color: "#cb6de9",
    sensortype_icon: "im im-icon-On-Off-3",
    sensortype_description: null,
    marker: "",
    group: null,
    group_name: null,
    metrics: [
      {
        content: "Κατάσταση",
        value: "Ενεργό",
      },
    ],
  },
  {
    mysensor_id: "379",
    ref_id: "379",
    mysensor_name: "Αγ. Παρασκευή Δημοτικό κεντρική",
    sensor_description: null,
    sensor_address: null,
    location_id: null,
    sensortype_id: "12",
    lat: "39.101747154411",
    lng: "20.990925907827",
    latlng: "20.990925907827,20.990925907827",
    location_name: null,
    location_lat: null,
    location_lng: null,
    sensortype_name: "Κατανάλωση ενέργειας",
    sensortype_color: "#cb6de9",
    sensortype_icon: "im im-icon-On-Off-3",
    sensortype_description: null,
    marker: "",
    group: null,
    group_name: null,
    metrics: [
      {
        content: "Κατάσταση",
        value: "Ενεργό",
      },
    ],
  },
  {
    mysensor_id: "380",
    ref_id: "380",
    mysensor_name: "Νεοχώρι Δημοτικό εξωτ.φώτα νέα",
    sensor_description: null,
    sensor_address: null,
    location_id: null,
    sensortype_id: "12",
    lat: "39.070609027069",
    lng: "21.017775893015",
    latlng: "21.017775893015,21.017775893015",
    location_name: null,
    location_lat: null,
    location_lng: null,
    sensortype_name: "Κατανάλωση ενέργειας",
    sensortype_color: "#cb6de9",
    sensortype_icon: "im im-icon-On-Off-3",
    sensortype_description: null,
    marker: "",
    group: null,
    group_name: null,
    metrics: [
      {
        content: "Κατάσταση",
        value: "Ενεργό",
      },
    ],
  },
  {
    mysensor_id: "381",
    ref_id: "381",
    mysensor_name: "Πέτα παιδικός πλυντ. κουζίνας",
    sensor_description: null,
    sensor_address: null,
    location_id: null,
    sensortype_id: "12",
    lat: "0",
    lng: "0",
    latlng: "0,0",
    location_name: null,
    location_lat: null,
    location_lng: null,
    sensortype_name: "Κατανάλωση ενέργειας",
    sensortype_color: "#cb6de9",
    sensortype_icon: "im im-icon-On-Off-3",
    sensortype_description: null,
    marker: "",
    group: null,
    group_name: null,
    metrics: [
      {
        content: "Κατάσταση",
        value: "Ενεργό",
      },
    ],
  },
  {
    mysensor_id: "382",
    ref_id: "382",
    mysensor_name: "Πέτα παιδικός πλυσταριό 1",
    sensor_description: null,
    sensor_address: null,
    location_id: null,
    sensortype_id: "12",
    lat: "39.175303581638",
    lng: "21.03431224823",
    latlng: "21.03431224823,21.03431224823",
    location_name: null,
    location_lat: null,
    location_lng: null,
    sensortype_name: "Κατανάλωση ενέργειας",
    sensortype_color: "#cb6de9",
    sensortype_icon: "im im-icon-On-Off-3",
    sensortype_description: null,
    marker: "",
    group: null,
    group_name: null,
    metrics: [
      {
        content: "Κατάσταση",
        value: "Ενεργό",
      },
    ],
  },
  {
    mysensor_id: "383",
    ref_id: "383",
    mysensor_name: "Πέτα νηπιαγωγείο κεντρική",
    sensor_description: null,
    sensor_address: null,
    location_id: null,
    sensortype_id: "12",
    lat: "39.174939704315",
    lng: "21.032708287239",
    latlng: "21.032708287239,21.032708287239",
    location_name: null,
    location_lat: null,
    location_lng: null,
    sensortype_name: "Κατανάλωση ενέργειας",
    sensortype_color: "#cb6de9",
    sensortype_icon: "im im-icon-On-Off-3",
    sensortype_description: null,
    marker: "",
    group: null,
    group_name: null,
    metrics: [
      {
        content: "Κατάσταση",
        value: "Ενεργό",
      },
    ],
  },
  {
    mysensor_id: "384",
    ref_id: "384",
    mysensor_name: "Πέτα Γυμνάσιο προβολείς",
    sensor_description: null,
    sensor_address: null,
    location_id: null,
    sensortype_id: "12",
    lat: "39.174361239405",
    lng: "21.034283816471",
    latlng: "21.034283816471,21.034283816471",
    location_name: null,
    location_lat: null,
    location_lng: null,
    sensortype_name: "Κατανάλωση ενέργειας",
    sensortype_color: "#cb6de9",
    sensortype_icon: "im im-icon-On-Off-3",
    sensortype_description: null,
    marker: "",
    group: null,
    group_name: null,
    metrics: [
      {
        content: "Κατάσταση",
        value: "Ενεργό",
      },
    ],
  },
  {
    mysensor_id: "385",
    ref_id: "385",
    mysensor_name: "Κομπότι παιδικός υπογ &κουζ ισογ",
    sensor_description: null,
    sensor_address: null,
    location_id: null,
    sensortype_id: "12",
    lat: "39.104197414779",
    lng: "21.082087755203",
    latlng: "21.082087755203,21.082087755203",
    location_name: null,
    location_lat: null,
    location_lng: null,
    sensortype_name: "Κατανάλωση ενέργειας",
    sensortype_color: "#cb6de9",
    sensortype_icon: "im im-icon-On-Off-3",
    sensortype_description: null,
    marker: "",
    group: null,
    group_name: null,
    metrics: [
      {
        content: "Κατάσταση",
        value: "Ενεργό",
      },
    ],
  },
  {
    mysensor_id: "386",
    ref_id: "386",
    mysensor_name: "Πέτα νηπιαγωγείο ηλ. κουζίνα",
    sensor_description: null,
    sensor_address: null,
    location_id: null,
    sensortype_id: "12",
    lat: "39.174912673353",
    lng: "21.032796800137",
    latlng: "21.032796800137,21.032796800137",
    location_name: null,
    location_lat: null,
    location_lng: null,
    sensortype_name: "Κατανάλωση ενέργειας",
    sensortype_color: "#cb6de9",
    sensortype_icon: "im im-icon-On-Off-3",
    sensortype_description: null,
    marker: "",
    group: null,
    group_name: null,
    metrics: [
      {
        content: "Κατάσταση",
        value: "Ενεργό",
      },
    ],
  },
  {
    mysensor_id: "387",
    ref_id: "387",
    mysensor_name: "Πέτα παιδικός πλυσταριό 2",
    sensor_description: null,
    sensor_address: null,
    location_id: null,
    sensortype_id: "12",
    lat: "39.175361801834",
    lng: "21.034280061722",
    latlng: "21.034280061722,21.034280061722",
    location_name: null,
    location_lat: null,
    location_lng: null,
    sensortype_name: "Κατανάλωση ενέργειας",
    sensortype_color: "#cb6de9",
    sensortype_icon: "im im-icon-On-Off-3",
    sensortype_description: null,
    marker: "",
    group: null,
    group_name: null,
    metrics: [
      {
        content: "Κατάσταση",
        value: "Ενεργό",
      },
    ],
  },
  {
    mysensor_id: "388",
    ref_id: "388",
    mysensor_name: "Αγ. Παρασκευή Κοινότ φώτα κολώνε",
    sensor_description: null,
    sensor_address: null,
    location_id: null,
    sensortype_id: "12",
    lat: "39.100958690169",
    lng: "20.983800888062",
    latlng: "20.983800888062,20.983800888062",
    location_name: null,
    location_lat: null,
    location_lng: null,
    sensortype_name: "Κατανάλωση ενέργειας",
    sensortype_color: "#cb6de9",
    sensortype_icon: "im im-icon-On-Off-3",
    sensortype_description: null,
    marker: "",
    group: null,
    group_name: null,
    metrics: [
      {
        content: "Κατάσταση",
        value: "Ενεργό",
      },
    ],
  },
  {
    mysensor_id: "389",
    ref_id: "389",
    mysensor_name: "Νεοχώρι Γυμν-Λύκειο 1ος όροφος",
    sensor_description: null,
    sensor_address: null,
    location_id: null,
    sensortype_id: "12",
    lat: "39.068813570689",
    lng: "21.018539786273",
    latlng: "21.018539786273,21.018539786273",
    location_name: null,
    location_lat: null,
    location_lng: null,
    sensortype_name: "Κατανάλωση ενέργειας",
    sensortype_color: "#cb6de9",
    sensortype_icon: "im im-icon-On-Off-3",
    sensortype_description: null,
    marker: "",
    group: null,
    group_name: null,
    metrics: [
      {
        content: "Κατάσταση",
        value: "Ενεργό",
      },
    ],
  },
  {
    mysensor_id: "390",
    ref_id: "390",
    mysensor_name: "Κομμένο Κοινότ. προβολείς",
    sensor_description: null,
    sensor_address: null,
    location_id: null,
    sensortype_id: "12",
    lat: "39.046229239195",
    lng: "21.03022670628",
    latlng: "21.03022670628,21.03022670628",
    location_name: null,
    location_lat: null,
    location_lng: null,
    sensortype_name: "Κατανάλωση ενέργειας",
    sensortype_color: "#cb6de9",
    sensortype_icon: "im im-icon-On-Off-3",
    sensortype_description: null,
    marker: "",
    group: null,
    group_name: null,
    metrics: [
      {
        content: "Κατάσταση",
        value: "Ενεργό",
      },
    ],
  },
  {
    mysensor_id: "391",
    ref_id: "391",
    mysensor_name: "Νεοχώρι Δημαρχείο 1ος όροφος",
    sensor_description: null,
    sensor_address: null,
    location_id: null,
    sensortype_id: "12",
    lat: "39.07341436194",
    lng: "21.022806642868",
    latlng: "21.022806642868,21.022806642868",
    location_name: null,
    location_lat: null,
    location_lng: null,
    sensortype_name: "Κατανάλωση ενέργειας",
    sensortype_color: "#cb6de9",
    sensortype_icon: "im im-icon-On-Off-3",
    sensortype_description: null,
    marker: "",
    group: null,
    group_name: null,
    metrics: [
      {
        content: "Κατάσταση",
        value: "Ενεργό",
      },
    ],
  },
  {
    mysensor_id: "392",
    ref_id: "392",
    mysensor_name: "Νεοχώρι Γυμν-Λύκειο ισόγειο",
    sensor_description: null,
    sensor_address: null,
    location_id: null,
    sensortype_id: "12",
    lat: "39.068771921895",
    lng: "21.018590748245",
    latlng: "21.018590748245,21.018590748245",
    location_name: null,
    location_lat: null,
    location_lng: null,
    sensortype_name: "Κατανάλωση ενέργειας",
    sensortype_color: "#cb6de9",
    sensortype_icon: "im im-icon-On-Off-3",
    sensortype_description: null,
    marker: "",
    group: null,
    group_name: null,
    metrics: [
      {
        content: "Κατάσταση",
        value: "Ενεργό",
      },
    ],
  },
  {
    mysensor_id: "393",
    ref_id: "393",
    mysensor_name: "Νεοχώρι Δημοτικό αιθ. υπολογιστ.",
    sensor_description: null,
    sensor_address: null,
    location_id: null,
    sensortype_id: "12",
    lat: "39.070667333857",
    lng: "21.017403065962",
    latlng: "21.017403065962,21.017403065962",
    location_name: null,
    location_lat: null,
    location_lng: null,
    sensortype_name: "Κατανάλωση ενέργειας",
    sensortype_color: "#cb6de9",
    sensortype_icon: "im im-icon-On-Off-3",
    sensortype_description: null,
    marker: "",
    group: null,
    group_name: null,
    metrics: [
      {
        content: "Κατάσταση",
        value: "Ενεργό",
      },
    ],
  },
  {
    mysensor_id: "394",
    ref_id: "394",
    mysensor_name: "Αγ. Δημήτριος Δημοτικό κυλικείο",
    sensor_description: null,
    sensor_address: null,
    location_id: null,
    sensortype_id: "12",
    lat: "39.160082337179",
    lng: "21.016599476125",
    latlng: "21.016599476125,21.016599476125",
    location_name: null,
    location_lat: null,
    location_lng: null,
    sensortype_name: "Κατανάλωση ενέργειας",
    sensortype_color: "#cb6de9",
    sensortype_icon: "im im-icon-On-Off-3",
    sensortype_description: null,
    marker: "",
    group: null,
    group_name: null,
    metrics: [
      {
        content: "Κατάσταση",
        value: "Ενεργό",
      },
    ],
  },
  {
    mysensor_id: "395",
    ref_id: "395",
    mysensor_name: "Αγ. Δημήτριος Δημοτικό 1ος όρ.",
    sensor_description: null,
    sensor_address: null,
    location_id: null,
    sensortype_id: "12",
    lat: "39.159988748653",
    lng: "21.016559242989",
    latlng: "21.016559242989,21.016559242989",
    location_name: null,
    location_lat: null,
    location_lng: null,
    sensortype_name: "Κατανάλωση ενέργειας",
    sensortype_color: "#cb6de9",
    sensortype_icon: "im im-icon-On-Off-3",
    sensortype_description: null,
    marker: "",
    group: null,
    group_name: null,
    metrics: [
      {
        content: "Κατάσταση",
        value: "Ενεργό",
      },
    ],
  },
  {
    mysensor_id: "396",
    ref_id: "396",
    mysensor_name: "Κομπότι Λύκειο όροφος Ν.2",
    sensor_description: null,
    sensor_address: null,
    location_id: null,
    sensortype_id: "12",
    lat: "39.103889367685",
    lng: "21.079341173172",
    latlng: "21.079341173172,21.079341173172",
    location_name: null,
    location_lat: null,
    location_lng: null,
    sensortype_name: "Κατανάλωση ενέργειας",
    sensortype_color: "#cb6de9",
    sensortype_icon: "im im-icon-On-Off-3",
    sensortype_description: null,
    marker: "",
    group: null,
    group_name: null,
    metrics: [
      {
        content: "Κατάσταση",
        value: "Ενεργό",
      },
    ],
  },
  {
    mysensor_id: "397",
    ref_id: "397",
    mysensor_name: "Κομμένο ΚΕΠ κεντρική",
    sensor_description: null,
    sensor_address: null,
    location_id: null,
    sensortype_id: "12",
    lat: "39.045945936308",
    lng: "21.030484198345",
    latlng: "21.030484198345,21.030484198345",
    location_name: null,
    location_lat: null,
    location_lng: null,
    sensortype_name: "Κατανάλωση ενέργειας",
    sensortype_color: "#cb6de9",
    sensortype_icon: "im im-icon-On-Off-3",
    sensortype_description: null,
    marker: "",
    group: null,
    group_name: null,
    metrics: [
      {
        content: "Κατάσταση",
        value: "Ενεργό",
      },
    ],
  },
  {
    mysensor_id: "398",
    ref_id: "398",
    mysensor_name: "Κομπότι Γυμνάσιο 1ος όροφος",
    sensor_description: null,
    sensor_address: null,
    location_id: null,
    sensortype_id: "12",
    lat: "39.104281919177",
    lng: "21.076850473373",
    latlng: "21.076850473373,21.076850473373",
    location_name: null,
    location_lat: null,
    location_lng: null,
    sensortype_name: "Κατανάλωση ενέργειας",
    sensortype_color: "#cb6de9",
    sensortype_icon: "im im-icon-On-Off-3",
    sensortype_description: null,
    marker: "",
    group: null,
    group_name: null,
    metrics: [
      {
        content: "Κατάσταση",
        value: "Ενεργό",
      },
    ],
  },
  {
    mysensor_id: "399",
    ref_id: "399",
    mysensor_name: "Κομπότι Δημαρχείο όροφος",
    sensor_description: null,
    sensor_address: null,
    location_id: null,
    sensortype_id: "12",
    lat: "39.102275012247",
    lng: "21.08397817592",
    latlng: "21.08397817592,21.08397817592",
    location_name: null,
    location_lat: null,
    location_lng: null,
    sensortype_name: "Κατανάλωση ενέργειας",
    sensortype_color: "#cb6de9",
    sensortype_icon: "im im-icon-On-Off-3",
    sensortype_description: null,
    marker: "",
    group: null,
    group_name: null,
    metrics: [
      {
        content: "Κατάσταση",
        value: "Ενεργό",
      },
    ],
  },
  {
    mysensor_id: "400",
    ref_id: "400",
    mysensor_name: "Νεοχώρι Δημαρχείο φώτα εξωτ.",
    sensor_description: null,
    sensor_address: null,
    location_id: null,
    sensortype_id: "12",
    lat: "39.073047875597",
    lng: "21.022484777786",
    latlng: "21.022484777786,21.022484777786",
    location_name: null,
    location_lat: null,
    location_lng: null,
    sensortype_name: "Κατανάλωση ενέργειας",
    sensortype_color: "#cb6de9",
    sensortype_icon: "im im-icon-On-Off-3",
    sensortype_description: null,
    marker: "",
    group: null,
    group_name: null,
    metrics: [
      {
        content: "Κατάσταση",
        value: "Ενεργό",
      },
    ],
  },
  {
    mysensor_id: "401",
    ref_id: "401",
    mysensor_name: "Πέτα Γυμνάσιο κεντρική",
    sensor_description: null,
    sensor_address: null,
    location_id: null,
    sensortype_id: "12",
    lat: "39.174419460382",
    lng: "21.034200667991",
    latlng: "21.034200667991,21.034200667991",
    location_name: null,
    location_lat: null,
    location_lng: null,
    sensortype_name: "Κατανάλωση ενέργειας",
    sensortype_color: "#cb6de9",
    sensortype_icon: "im im-icon-On-Off-3",
    sensortype_description: null,
    marker: "",
    group: null,
    group_name: null,
    metrics: [
      {
        content: "Κατάσταση",
        value: "Ενεργό",
      },
    ],
  },
  {
    mysensor_id: "402",
    ref_id: "402",
    mysensor_name: "Πέτα Γυμνάσιο όροφ & αιθ. υπολ.",
    sensor_description: null,
    sensor_address: null,
    location_id: null,
    sensortype_id: "12",
    lat: "39.174290542439",
    lng: "21.034275769844",
    latlng: "21.034275769844,21.034275769844",
    location_name: null,
    location_lat: null,
    location_lng: null,
    sensortype_name: "Κατανάλωση ενέργειας",
    sensortype_color: "#cb6de9",
    sensortype_icon: "im im-icon-On-Off-3",
    sensortype_description: null,
    marker: "",
    group: null,
    group_name: null,
    metrics: [
      {
        content: "Κατάσταση",
        value: "Ενεργό",
      },
    ],
  },
  {
    mysensor_id: "403",
    ref_id: "403",
    mysensor_name: "Νεοχώρι Γυμν-Λύκειο κυλικείο",
    sensor_description: null,
    sensor_address: null,
    location_id: null,
    sensortype_id: "12",
    lat: "39.068759427252",
    lng: "21.018614888126",
    latlng: "21.018614888126,21.018614888126",
    location_name: null,
    location_lat: null,
    location_lng: null,
    sensortype_name: "Κατανάλωση ενέργειας",
    sensortype_color: "#cb6de9",
    sensortype_icon: "im im-icon-On-Off-3",
    sensortype_description: null,
    marker: "",
    group: null,
    group_name: null,
    metrics: [
      {
        content: "Κατάσταση",
        value: "Ενεργό",
      },
    ],
  },
  {
    mysensor_id: "404",
    ref_id: "404",
    mysensor_name: "Νεοχώρι Δημαρχείο εξωτ. φωτισμός",
    sensor_description: null,
    sensor_address: null,
    location_id: null,
    sensortype_id: "12",
    lat: "39.072748021719",
    lng: "21.022377489426",
    latlng: "21.022377489426,21.022377489426",
    location_name: null,
    location_lat: null,
    location_lng: null,
    sensortype_name: "Κατανάλωση ενέργειας",
    sensortype_color: "#cb6de9",
    sensortype_icon: "im im-icon-On-Off-3",
    sensortype_description: null,
    marker: "",
    group: null,
    group_name: null,
    metrics: [
      {
        content: "Κατάσταση",
        value: "Ενεργό",
      },
    ],
  },
  {
    mysensor_id: "405",
    ref_id: "405",
    mysensor_name: "Πέτα παιδικός Ηλ. Κουζίνα",
    sensor_description: null,
    sensor_address: null,
    location_id: null,
    sensortype_id: "12",
    lat: "39.175203775474",
    lng: "21.034333705902",
    latlng: "21.034333705902,21.034333705902",
    location_name: null,
    location_lat: null,
    location_lng: null,
    sensortype_name: "Κατανάλωση ενέργειας",
    sensortype_color: "#cb6de9",
    sensortype_icon: "im im-icon-On-Off-3",
    sensortype_description: null,
    marker: "",
    group: null,
    group_name: null,
    metrics: [
      {
        content: "Κατάσταση",
        value: "Ενεργό",
      },
    ],
  },
  {
    mysensor_id: "406",
    ref_id: "406",
    mysensor_name: "Κομπότι Λύκειο Ισόγειο Ν.1",
    sensor_description: null,
    sensor_address: null,
    location_id: null,
    sensortype_id: "12",
    lat: "39.103947646968",
    lng: "21.079287528992",
    latlng: "21.079287528992,21.079287528992",
    location_name: null,
    location_lat: null,
    location_lng: null,
    sensortype_name: "Κατανάλωση ενέργειας",
    sensortype_color: "#cb6de9",
    sensortype_icon: "im im-icon-On-Off-3",
    sensortype_description: null,
    marker: "",
    group: null,
    group_name: null,
    metrics: [
      {
        content: "Κατάσταση",
        value: "Ενεργό",
      },
    ],
  },
  {
    mysensor_id: "407",
    ref_id: "407",
    mysensor_name: "Κομπότι Παιδικός 1ος Όροφος",
    sensor_description: null,
    sensor_address: null,
    location_id: null,
    sensortype_id: "12",
    lat: "39.104055879795",
    lng: "21.082366704941",
    latlng: "21.082366704941,21.082366704941",
    location_name: null,
    location_lat: null,
    location_lng: null,
    sensortype_name: "Κατανάλωση ενέργειας",
    sensortype_color: "#cb6de9",
    sensortype_icon: "im im-icon-On-Off-3",
    sensortype_description: null,
    marker: "",
    group: null,
    group_name: null,
    metrics: [
      {
        content: "Κατάσταση",
        value: "Ενεργό",
      },
    ],
  },
  {
    mysensor_id: "408",
    ref_id: "408",
    mysensor_name: "Πέτα ΚΕΠ κεντρική",
    sensor_description: null,
    sensor_address: null,
    location_id: null,
    sensortype_id: "12",
    lat: "39.1668449223",
    lng: "21.034715116057",
    latlng: "21.034715116057,21.034715116057",
    location_name: null,
    location_lat: null,
    location_lng: null,
    sensortype_name: "Κατανάλωση ενέργειας",
    sensortype_color: "#cb6de9",
    sensortype_icon: "im im-icon-On-Off-3",
    sensortype_description: null,
    marker: "",
    group: null,
    group_name: null,
    metrics: [
      {
        content: "Κατάσταση",
        value: "Ενεργό",
      },
    ],
  },
  {
    mysensor_id: "409",
    ref_id: "409",
    mysensor_name: "Κομπότι Παιδικός Κουζ. Ισόγειο",
    sensor_description: null,
    sensor_address: null,
    location_id: null,
    sensortype_id: "12",
    lat: "39.104222391512",
    lng: "21.082291603088",
    latlng: "21.082291603088,21.082291603088",
    location_name: null,
    location_lat: null,
    location_lng: null,
    sensortype_name: "Κατανάλωση ενέργειας",
    sensortype_color: "#cb6de9",
    sensortype_icon: "im im-icon-On-Off-3",
    sensortype_description: null,
    marker: "",
    group: null,
    group_name: null,
    metrics: [
      {
        content: "Κατάσταση",
        value: "Ενεργό",
      },
    ],
  },
  {
    mysensor_id: "410",
    ref_id: "410",
    mysensor_name: "Κομπότι Λύκειο Ισόγειο Ν.2",
    sensor_description: null,
    sensor_address: null,
    location_id: null,
    sensortype_id: "12",
    lat: "39.104105833351",
    lng: "21.079555749893",
    latlng: "21.079555749893,21.079555749893",
    location_name: null,
    location_lat: null,
    location_lng: null,
    sensortype_name: "Κατανάλωση ενέργειας",
    sensortype_color: "#cb6de9",
    sensortype_icon: "im im-icon-On-Off-3",
    sensortype_description: null,
    marker: "",
    group: null,
    group_name: null,
    metrics: [
      {
        content: "Κατάσταση",
        value: "Ενεργό",
      },
    ],
  },
  {
    mysensor_id: "411",
    ref_id: "411",
    mysensor_name: "Κομπότι Δημαρχείο αιθ. πολλ. χρ.",
    sensor_description: null,
    sensor_address: null,
    location_id: null,
    sensortype_id: "12",
    lat: "39.102216731581",
    lng: "21.083975493711",
    latlng: "21.083975493711,21.083975493711",
    location_name: null,
    location_lat: null,
    location_lng: null,
    sensortype_name: "Κατανάλωση ενέργειας",
    sensortype_color: "#cb6de9",
    sensortype_icon: "im im-icon-On-Off-3",
    sensortype_description: null,
    marker: "",
    group: null,
    group_name: null,
    metrics: [
      {
        content: "Κατάσταση",
        value: "Ενεργό",
      },
    ],
  },
  {
    mysensor_id: "412",
    ref_id: "412",
    mysensor_name: "Κομμένο ΚΕΠ Κοινοτικό Γραφείο",
    sensor_description: null,
    sensor_address: null,
    location_id: null,
    sensortype_id: "12",
    lat: "39.046312563357",
    lng: "21.031771658672",
    latlng: "21.031771658672,21.031771658672",
    location_name: null,
    location_lat: null,
    location_lng: null,
    sensortype_name: "Κατανάλωση ενέργειας",
    sensortype_color: "#cb6de9",
    sensortype_icon: "im im-icon-On-Off-3",
    sensortype_description: null,
    marker: "",
    group: null,
    group_name: null,
    metrics: [
      {
        content: "Κατάσταση",
        value: "Ενεργό",
      },
    ],
  },
];

export const getTextColor = (bgColor) => {
  if (bgColor) {
    const rgba = bgColor?.match(/\d+/g).map(Number);
    const [r, g, b] = rgba;

    // Convert RGB to luminance
    const luminance = 0.299 * r + 0.587 * g + 0.114 * b;
    return luminance > 140 ? "#000" : "#fff"; // threshold can be tuned
  } else {
    return "#000";
  }
};

export const getCircleColor = (value, name) => {
  switch (name) {
    case "Θερμοκρασία":
    case "Θερμοκρασία αέρα":
    case "Αίσθηση Θερμοκρασίας":
    case "Αίσθηση θερμοκρασίας":
    case "Σημείο δρόσου":
      return value < 15
        ? "rgba(0, 132, 255, 0.2)"
        : value < 20
        ? "rgb(0, 255, 106)"
        : value < 25
        ? "rgba(0, 255, 0, 1)"
        : value < 30
        ? "rgba(255, 255, 0, 1)"
        : "rgba(255, 0, 0, 1)";
    case "Υγρασία":
    case "Σχετική υγρασία":
      return value < 30
        ? "rgba(255, 0, 0, 0.8)"
        : value < 50
        ? "rgba(255, 165, 0, 1)"
        : value < 70
        ? "rgba(255, 255, 0, 1)"
        : value < 85
        ? "rgba(0, 255, 106, 1)"
        : "rgba(0, 132, 255, 0.6)";
    case "Πίεση":
    case "Ατμοσφαιρική πίεση":
      return value < 900
        ? "rgba(255, 0, 0, 1)"
        : value < 1000
        ? "rgba(255, 165, 0, 1)"
        : value < 1020
        ? "rgba(0, 255, 0, 1)"
        : value < 1040
        ? "rgba(0, 132, 255, 0.8)"
        : "rgba(0, 0, 255, 1)";
    case "Ταχύτητα ανέμου":
    case "Δείκτης UV":
      return value < 2
        ? "rgba(0, 255, 106, 1)"
        : value < 5
        ? "rgba(255, 255, 0, 1)"
        : value < 8
        ? "rgba(255, 165, 0, 1)"
        : "rgba(255, 0, 0, 1)";
    case "Σωματίδια σκόνης PM1":
    case "Σωματίδια σκόνης PM2.5":
    case "Σωματίδια σκόνης PM4":
    case "Σωματίδια σκόνης PM10":
    case "Ολικά αιωρούμενα σωματίδια (TSP)":
    case "Συνολική συγκέντρ. σωματιδίων (TPC)":
      return value < 10
        ? "rgba(0, 255, 106, 1)"
        : value < 25
        ? "rgba(255, 255, 0, 1)"
        : value < 50
        ? "rgba(255, 165, 0, 1)"
        : "rgba(255, 0, 0, 1)";
    case "Τελευταία βροχόπτωση":
    case "Βροχόπτωση τελευτ. μέρας":
    case "Ένταση βροχόπτωσης":
    case "Ημερήσια ένταση βροχόπτωσης":
      return value === 0
        ? "rgba(200, 200, 200, 0.5)"
        : value < 2
        ? "rgba(0, 255, 106, 1)"
        : value < 5
        ? "rgba(0, 132, 255, 1)"
        : value < 10
        ? "rgba(0, 0, 200, 1)"
        : "rgba(0, 0, 150, 1)";
    case "Μέση στάθμη θορύβου":
    case "Μέγιστη στάθμη θορύβου":
    case "Ελάχιστη  στάθμη θορύβου":
      return value < 40
        ? "rgba(0, 255, 106, 1)"
        : value < 60
        ? "rgba(255, 255, 0, 1)"
        : value < 80
        ? "rgba(255, 165, 0, 1)"
        : "rgba(255, 0, 0, 1)";
    case "Μονοξείδιο του άνθρακα (ppb)":
    case "Μονοξείδιο του αζώτου (ppb)":
    case "Διοξείδιο του αζώτου (ppb)":
    case "Όζον (ppb)":
      return value < 50
        ? "rgba(0, 255, 106, 1)"
        : value < 100
        ? "rgba(255, 255, 0, 1)"
        : value < 200
        ? "rgba(255, 165, 0, 1)"
        : "rgba(255, 0, 0, 1)";
    case "Δείκτης ποιότητας αέρα AQI EU":
      return value < 50
        ? "rgba(0, 255, 106, 1)"
        : value < 100
        ? "rgba(255, 255, 0, 1)"
        : value < 150
        ? "rgba(255, 165, 0, 1)"
        : value < 200
        ? "rgba(255, 0, 0, 1)"
        : value < 300
        ? "rgba(153, 50, 204, 1)"
        : "rgba(128, 0, 0, 1)";

    default:
      return "rgba(100, 100, 100, 1)";
  }
};
// case "":
// return value < 30 ? "" : value < 50 ? "" : value < 70 ? "" : value < 85 ? "" : "";
